webpackJsonp([72138227098318],{

/***/ "./src/assets/FeatureIcons.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Sample3 = exports.Sample2 = exports.unlimited = exports.slack = exports.analytics = exports.editMessages = exports.autoMessages = exports.customizable = exports.easyInstall = exports.contactList = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactList = exports.contactList = function contactList(_ref) {
	  var style = _ref.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-341.000000, -1897.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Contact-List---Feature-Set",
	              transform: "translate(83.000000, 141.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-30", transform: "translate(0.000000, 3.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-18",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-19",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(29.000000, 19.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M8.50250442,5.08816214 L19.2164965,11.5927557 L19.2164965,11.5927557 C19.8567472,11.9814596 20.6605226,11.9798422 21.2992038,11.5885648 L36.9524628,1.99885639",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              ),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(46.000000, 33.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M7.73975993,4.53278256 L19.2144213,11.5837929 L19.2144213,11.5837929 C19.8554502,11.9776957 20.6633077,11.978514 21.3051333,11.5859106 L36.9290487,2.02879332",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              ),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-29", transform: "translate(23.000000, 44.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  fill: "#F7F7F9",
	                  x: "0",
	                  y: "1",
	                  width: "38",
	                  height: "20",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M5,6.99620141 L19.2008109,15.791534 L19.2008109,15.791534 C19.8487274,16.1928238 20.6683959,16.1910037 21.3145239,15.7868405 L34.2876306,7.67195665",
	                  id: "Path-20-Copy",
	                  stroke: "#9192C5",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(19.643815, 11.543719) scale(1, -1) translate(-19.643815, -11.543719) "
	                }),
	                _react2.default.createElement("polygon", {
	                  id: "Path-20",
	                  fill: "#D6D6E0",
	                  points: "2 1 20.2030714 12 38 1"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M8.58458475,5.12960041 L19.207944,11.5868076 L19.207944,11.5868076 C19.8526403,11.978674 20.6629903,11.9744053 21.3035225,11.5757686 L36.6980868,1.99492494",
	                  id: "Path-20",
	                  stroke: "#222232",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-46",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  x: "2",
	                  y: "1",
	                  width: "36",
	                  height: "18",
	                  rx: "3"
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var easyInstall = exports.easyInstall = function easyInstall(_ref2) {
	  var style = _ref2.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-340.000000, -2030.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Easy-Install---Feature-Set",
	              transform: "translate(82.000000, 275.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-31", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-9",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-10",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement("path", {
	                d: "M25.391114,42.2440523 L23.6079109,42.8670991 L24.6606453,43.2967866 L37.0117188,48.8183691 L37.0117188,53.8278222 L18.4086921,45.5189894 L18.4086921,40.224521 L37.0117188,32.0148441 L37.0117188,37.7640632 L25.391114,42.2440523 Z M46.0390625,58.6855469 L40.4101562,58.6855469 L54.6282403,24.71875 L60.2786309,24.71875 L46.0390625,58.6855469 Z M63.8233095,37.9230472 L63.8233095,32.0148441 L81.9199219,40.0800781 L81.9199219,44.8925781 L63.8233095,53.2953264 L63.8233095,47.0968754 L74.3359375,43.0019531 L75.9472656,42.5078125 L75.0449219,42.1425781 L63.8233095,37.9230472 Z",
	                id: "<-/->",
	                fill: "#F7F7F9"
	              }),
	              _react2.default.createElement("path", {
	                d: "M22.4882812,41.90625 L37.9785156,48.3515625 L37.9785156,51.0585938 L19.5664062,42.9160156 L19.5664062,40.8535156 L37.9785156,32.7324219 L37.9785156,35.4179688 L22.4882812,41.90625 Z M47.2089844,58.6855469 L44.8027344,58.6855469 L57.8652344,24.71875 L60.2714844,24.71875 L47.2089844,58.6855469 Z M81.3398438,41.8203125 L65.5488281,35.3320312 L65.5488281,32.6894531 L84.3261719,40.8105469 L84.3261719,42.8730469 L65.5488281,51.015625 L65.5488281,48.3730469 L81.3398438,41.8203125 Z",
	                id: "<-/->",
	                fill: "#000000"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var customizable = exports.customizable = function customizable(_ref3) {
	  var style = _ref3.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-340.000000, -2161.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Customizable---Feature-Set",
	              transform: "translate(82.000000, 406.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                {
	                  id: "Customizable---Feature-Set",
	                  transform: "translate(28.000000, 28.000000)",
	                  stroke: "#FFFFFF",
	                  strokeWidth: "3",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round" },
	                _react2.default.createElement("path", { d: "M0,1.5 L50,1.5", id: "Line-12-Copy-3" })
	              ),
	              _react2.default.createElement("path", {
	                d: "M28,41.5 L78,41.5",
	                id: "Line-12-Copy-4",
	                stroke: "#FFFFFF",
	                strokeWidth: "3",
	                strokeLinecap: "round",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28,53.5 L78,53.5",
	                id: "Line-12-Copy-5",
	                stroke: "#FFFFFF",
	                strokeWidth: "3",
	                strokeLinecap: "round",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M71.5,54.5 L52.5,54.5",
	                id: "Line-13-Copy-3",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M48.5,42.5 L29.5,42.5",
	                id: "Line-13-Copy-4",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M49.5,30.5 L30.5,30.5",
	                id: "Line-13-Copy-5",
	                stroke: "#222232",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-3",
	                fill: "#F7F7F9",
	                cx: "44",
	                cy: "29",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-4",
	                fill: "#F7F7F9",
	                cx: "36",
	                cy: "41",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-5",
	                fill: "#F7F7F9",
	                cx: "70",
	                cy: "53",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-6",
	                fill: "#9192C5",
	                cx: "42",
	                cy: "30",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-7",
	                fill: "#9192C5",
	                cx: "34",
	                cy: "42",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-8",
	                fill: "#9192C5",
	                cx: "68",
	                cy: "54",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-9",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "44",
	                cy: "29",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-10",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "36",
	                cy: "41",
	                r: "4"
	              }),
	              _react2.default.createElement("circle", {
	                id: "Oval-13-Copy-11",
	                stroke: "#222232",
	                strokeWidth: "2",
	                cx: "70",
	                cy: "53",
	                r: "4"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var autoMessages = exports.autoMessages = function autoMessages(_ref4) {
	  var style = _ref4.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-855.000000, -1899.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Auto-Message---Feature-Set",
	              transform: "translate(597.000000, 141.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 5.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-22-Copy", transform: "translate(18.000000, 21.000000)" },
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11",
	                  fill: "#EBECEF",
	                  cx: "20.5",
	                  cy: "19",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M11.9995947,40 L18.022421,36.0761035 C20.058443,36.6878675 22.2363762,37.0191304 24.5,37.0191304 C35.8218374,37.0191304 45,28.7321158 45,18.5095652 C45,8.28701461 35.8218374,0 24.5,0 C22.9753566,0 21.4895874,0.150279875 20.059871,0.435329014 C16.0319188,1.2384004 12.44887,3.11116611 9.69486511,5.70678375 C8.76116213,6.58678796 7.92275315,7.54988 7.19460818,8.58254336 C5.17184446,11.4512496 4,14.8568452 4,18.5095652 C4,24.0337041 6.68019502,28.9926303 10.9305199,32.3840599",
	                  id: "Combined-Shape",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round"
	                }),
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11",
	                  fill: "#FFFFFF",
	                  cx: "39.5",
	                  cy: "25",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M29.9995947,47 L36.022421,43.0761035 C38.058443,43.6878675 40.2363762,44.0191304 42.5,44.0191304 C53.8218374,44.0191304 63,35.7321158 63,25.5095652 C63,15.2870146 53.8218374,7 42.5,7 C40.9753566,7 39.4895874,7.15027988 38.059871,7.43532901 C34.0319188,8.2384004 30.44887,10.1111661 27.6948651,12.7067838 C26.7611621,13.586788 25.9227532,14.54988 25.1946082,15.5825434 C23.1718445,18.4512496 22,21.8568452 22,25.5095652 C22,31.0337041 24.680195,35.9926303 28.9305199,39.3840599",
	                  id: "Combined-Shape-Copy-2",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(42.500000, 27.000000) scale(-1, 1) translate(-42.500000, -27.000000) "
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var editMessages = exports.editMessages = function editMessages(_ref5) {
	  var style = _ref5.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-857.000000, -2030.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Message-Editing---Feature-Set",
	              transform: "translate(599.000000, 275.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-32", transform: "translate(0.000000, 2.000000)" },
	              _react2.default.createElement("path", {
	                d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	                id: "Rectangle-19-Copy-20",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	                id: "Rectangle-19-Copy-21",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-22-Copy", transform: "translate(28.000000, 18.000000)" },
	                _react2.default.createElement("ellipse", {
	                  id: "Oval-11-Copy",
	                  fill: "#FFFFFF",
	                  cx: "20.5",
	                  cy: "26",
	                  rx: "20.5",
	                  ry: "18"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M10.9995947,48 L17.022421,44.0761035 C19.058443,44.6878675 21.2363762,45.0191304 23.5,45.0191304 C34.8218374,45.0191304 44,36.7321158 44,26.5095652 C44,16.2870146 34.8218374,8 23.5,8 C21.9753566,8 20.4895874,8.15027988 19.059871,8.43532901 C15.0319188,9.2384004 11.44887,11.1111661 8.69486511,13.7067838 C7.76116213,14.586788 6.92275315,15.54988 6.19460818,16.5825434 C4.17184446,19.4512496 3,22.8568452 3,26.5095652 C3,32.0337041 5.68019502,36.9926303 9.93051993,40.3840599",
	                  id: "Combined-Shape-Copy-3",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  strokeLinejoin: "round",
	                  transform: "translate(23.500000, 28.000000) scale(-1, 1) translate(-23.500000, -28.000000) "
	                }),
	                _react2.default.createElement("path", {
	                  d: "M32.4767288,-0.221782976 L34.6019832,-0.39688284 L34.6019832,-0.39688284 C36.2532425,-0.532930207 37.7021408,0.695391721 37.8381881,2.34665097 C37.8413529,2.3850627 37.8437771,2.42353185 37.8454594,2.46203699 L38.6899618,21.7907998 L34.9235178,28.3564521 L34.9235178,28.3564521 C34.6487028,28.8355087 34.0375691,29.0010792 33.5585126,28.7262642 C33.41106,28.6416767 33.2876046,28.5208965 33.1998077,28.375332 L30.2978587,23.5639933 L30.2978587,23.5639933 C29.9218045,22.9405075 29.7230643,22.2262025 29.7230643,21.4980876 L29.7230643,2.76808638 L29.7230643,2.76808638 C29.7230643,1.20674101 30.9206559,-0.0935780198 32.4767288,-0.221782976 Z",
	                  id: "Rectangle-9",
	                  fill: "#9192C5",
	                  transform: "translate(34.206513, 14.225924) rotate(-315.000000) translate(-34.206513, -14.225924) "
	                }),
	                _react2.default.createElement(
	                  "g",
	                  {
	                    id: "pencil",
	                    transform: "translate(22.000000, 0.000000)",
	                    stroke: "#222232" },
	                  _react2.default.createElement(
	                    "g",
	                    {
	                      id: "Group-7-Copy",
	                      transform: "translate(13.849242, 13.849242) rotate(-225.000000) translate(-13.849242, -13.849242) translate(-1.150758, 9.849242)" },
	                    _react2.default.createElement("rect", {
	                      id: "Rectangle-19",
	                      strokeWidth: "2",
	                      x: "5.53713536",
	                      y: "1",
	                      width: "16.9047307",
	                      height: "5.56189227"
	                    }),
	                    _react2.default.createElement("path", {
	                      d: "M23.9675791,6.56189227 L28.4494334,3.91657194 C28.7524791,3.73770562 28.7525398,3.77965392 28.4525808,3.60266868 L24.0415131,1 L3.79858159,1 C2.25841341,1 1.01514008,2.24347728 1.01514008,3.78094613 C1.01514008,5.31395832 2.26352253,6.56189227 3.80038106,6.56189227 L23.9675791,6.56189227 Z",
	                      id: "Rectangle-19-Copy-2",
	                      strokeWidth: "2"
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var analytics = exports.analytics = function analytics(_ref6) {
	  var style = _ref6.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "98px",
	      height: "85px",
	      viewBox: "0 0 98 85",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "Landing-Page-Copy",
	          transform: "translate(-856.000000, -2162.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Feature-Set", transform: "translate(258.000000, 1753.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Analytics---Feature-Set",
	              transform: "translate(598.000000, 406.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-23", transform: "translate(0.000000, 3.000000)" },
	              _react2.default.createElement("path", {
	                d: "M24.4905599,4.58447451 L27.4417745,3.75596891 L27.4417745,3.75596891 C40.5033442,0.0891452598 54.3211933,0.0806289737 67.3872731,3.7313495 L70.5962402,4.62794914 L70.5962402,4.62794914 C81.1401053,7.57395173 89.4297989,15.732231 92.5438992,26.2276777 L92.5697889,26.3149337 L92.5697889,26.3149337 C95.8182862,37.2633383 95.8092903,48.9206435 92.5438992,59.8640212 L92.5438992,59.8640212 L92.5438992,59.8640212 C89.429237,70.3022582 81.1745416,78.410983 70.6824013,81.3389349 L67.3168622,82.2781272 L67.3168622,82.2781272 C54.2645817,85.9205156 40.4625522,85.9075932 27.4171151,82.2407705 L24.240531,81.3478935 L24.240531,81.3478935 C13.7988698,78.4129424 5.58444466,70.3402119 2.46827125,59.9511941 L2.46827125,59.9511941 L2.46827125,59.9511941 C-0.797112839,49.0647225 -0.822504615,37.4630716 2.39519539,26.5624109 L2.46827125,26.3148505 L2.46827125,26.3148505 C5.58229344,15.7654211 13.9005186,7.55745666 24.4905599,4.58447451 Z",
	                id: "Rectangle-19-Copy-16",
	                fill: "#B6BFF3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M27.7608448,4.54725488 C17.5020342,7.42724943 9.44398265,15.3784888 6.42735945,25.597958 L6.3542836,25.8455184 C3.19155442,36.5599534 3.21651241,47.9634029 6.42611103,58.6638912 C9.4439219,68.7249779 17.3990573,76.5428913 27.5111257,79.3852002 L30.6877098,80.2780772 C43.5567917,83.8953298 57.1722379,83.9080774 70.0480707,80.3149288 L73.4136097,79.3757366 C83.5748535,76.5401251 91.5692159,68.6871297 94.5856493,58.5780893 C97.7955238,47.8207653 97.8043668,36.3616517 94.6110988,25.5993863 L94.5852091,25.5121303 C91.5689534,15.346449 83.5397207,7.44450158 73.3271423,4.59106195 L70.1181751,3.69446231 C57.2285263,0.0930373555 43.5972592,0.101438646 30.7120595,3.71874928 L27.7608448,4.54725488 Z",
	                id: "Rectangle-19-Copy-17",
	                stroke: "#222232",
	                strokeWidth: "2"
	              }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-28", transform: "translate(25.000000, 25.000000)" },
	                _react2.default.createElement("rect", {
	                  id: "Rectangle-45",
	                  fill: "#FFFFFF",
	                  x: "0",
	                  y: "3",
	                  width: "50",
	                  height: "30",
	                  rx: "3"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M3.69324136,28.8950601 L9.11019346,19.3409746 L9.11019346,19.3409746 C9.65498621,18.3801028 10.8755685,18.0428041 11.8364403,18.5875968 C11.8411173,18.5902486 11.8457836,18.5929191 11.850439,18.5956085 L15.5241629,20.7178594 L15.5241629,20.7178594 C17.0468352,21.5974826 18.9654005,21.3794974 20.2519247,20.1806966 L26.0935078,14.7374293 L26.0935078,14.7374293 C26.6940211,14.1778628 27.5754617,14.0420176 28.3165859,14.3948147 L33.0555244,16.6506897 L33.0555244,16.6506897 C34.2818599,17.2344617 35.7206363,17.1560665 36.8762835,16.4425064 L48.9298034,9 L48.9298034,29.8814947 L48.9298034,29.8814947 C48.9298034,30.9860642 48.0343729,31.8814947 46.9298034,31.8814947 L5.43305368,31.8814947 L5.43305368,31.8814947 C4.32848418,31.8814947 3.43305368,30.9860642 3.43305368,29.8814947 C3.43305368,29.5357199 3.52269929,29.1958517 3.69324136,28.8950601 Z",
	                  id: "Path-4",
	                  fill: "#EBECEF"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M2.91741078,30.2302125 L12.1588613,17.8788385 L12.1588613,17.8788385 C12.4207982,17.5287548 12.8798004,17.3894323 13.2921388,17.5348509 L20.1018015,19.9364007 L20.1018015,19.9364007 C20.8006688,20.1828688 21.5785318,20.0227064 22.1231842,19.520197 L28.9214226,13.2479787 L28.9214226,13.2479787 C29.2362683,12.9574945 29.7011647,12.8998146 30.0774523,13.1045497 L35.9705581,16.3109404 L35.9705581,16.3109404 C36.7187632,16.7180327 37.6427079,16.6065721 38.2726375,16.0332279 L46,9",
	                  id: "Path-4",
	                  stroke: "#9192C5",
	                  strokeWidth: "2",
	                  strokeLinecap: "round"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M2,8 L2,28.3057804 L2,28.3057804 C2,29.9626346 3.34314575,31.3057804 5,31.3057804 L42.9338268,31.3057804",
	                  id: "Path-19",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M38.8107389,-3.55271368e-15 L38.8107389,12.6460872 L38.8107389,12.6460872 C38.8107389,14.3029415 40.1538847,15.6460872 41.8107389,15.6460872 L52.9338268,15.6460872",
	                  id: "Path-19-Copy",
	                  stroke: "#222232",
	                  strokeWidth: "2",
	                  strokeLinecap: "round",
	                  transform: "translate(45.872283, 7.823044) scale(-1, -1) translate(-45.872283, -7.823044) "
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var slack = exports.slack = function slack(_ref7) {
	  var style = _ref7.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-598.000000, -511.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-31-Copy", transform: "translate(598.000000, 511.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-42" },
	            _react2.default.createElement("path", {
	              d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	              id: "Rectangle-19-Copy-9",
	              fill: "#B6BFF3"
	            }),
	            _react2.default.createElement("path", {
	              d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	              id: "Rectangle-19-Copy-10",
	              stroke: "#222232",
	              strokeWidth: "2"
	            }),
	            _react2.default.createElement(
	              "g",
	              {
	                id: "slack",
	                transform: "translate(25.000000, 19.000000)",
	                fillRule: "nonzero" },
	              _react2.default.createElement("path", {
	                d: "M17.4126232,24.6244729 L20.5824922,33.405262 L30.0382807,30.2952024 L26.8684116,21.5144133 L17.4126232,24.6244729 Z M14.9833728,17.8952564 L24.4391612,14.7851967 L22.265216,8.76319578 C21.5946306,6.90562108 22.5855351,4.86519279 24.4784631,4.20577164 C26.3713911,3.54635049 28.4495293,4.51764584 29.1201146,6.37522054 L31.337094,12.5164295 L36.8299735,10.709792 C38.7341217,10.0835074 40.7949919,11.0909233 41.433056,12.9599184 C42.0711201,14.8289135 41.0447561,16.8517374 39.1406079,17.478022 L33.7663444,19.2456461 L36.9362135,28.0264352 L42.2075103,26.2926774 C44.1116584,25.6663928 46.1725287,26.6738087 46.8105927,28.5428038 C47.4486568,30.411799 46.4222928,32.4346228 44.5181447,33.0609074 L39.3654639,34.7556518 L41.2165183,39.8832195 C41.8871036,41.7407942 40.8961991,43.7812225 39.0032711,44.4406436 C37.1103431,45.1000648 35.032205,44.1287694 34.3616196,42.2711947 L32.4675311,37.024419 L23.0117426,40.1344786 L24.8536846,45.2368042 C25.52427,47.0943789 24.5333655,49.1348072 22.6404375,49.7942284 C20.7475095,50.4536495 18.6693713,49.4823542 17.998786,47.6247795 L16.1138098,42.4032458 L10.1700265,44.3581881 C8.2658783,44.9844726 6.20500808,43.9770567 5.56694401,42.1080616 C4.92887993,40.2390665 5.9552439,38.2162426 7.85939208,37.5899581 L13.6845594,35.6740292 L10.5146903,26.8932401 L4.79248973,28.7753026 C2.88834155,29.4015872 0.827471333,28.3941713 0.189407261,26.5251762 C-0.44865681,24.6561811 0.577707151,22.6333572 2.48185533,22.0070726 L8.08543994,20.1640235 L5.90238232,14.1167805 C5.23179697,12.2592058 6.22270147,10.2187775 8.11562947,9.55935639 C10.0085575,8.89993524 12.0866956,9.8712306 12.757281,11.7288053 L14.9833728,17.8952564 Z",
	                id: "Combined-Shape",
	                fill: "#9192C5"
	              }),
	              _react2.default.createElement("path", {
	                d: "M20.4126232,21.6244729 L23.5824922,30.405262 L33.0382807,27.2952024 L29.8684116,18.5144133 L20.4126232,21.6244729 Z M17.9833728,14.8952564 L27.4391612,11.7851967 L25.265216,5.76319578 C24.5946306,3.90562108 25.5855351,1.86519279 27.4784631,1.20577164 C29.3713911,0.546350487 31.4495293,1.51764584 32.1201146,3.37522054 L34.337094,9.51642955 L39.8299735,7.70979196 C41.7341217,7.08350739 43.7949919,8.09092332 44.433056,9.95991843 C45.0711201,11.8289135 44.0447561,13.8517374 42.1406079,14.478022 L36.7663444,16.2456461 L39.9362135,25.0264352 L45.2075103,23.2926774 C47.1116584,22.6663928 49.1725287,23.6738087 49.8105927,25.5428038 C50.4486568,27.411799 49.4222928,29.4346228 47.5181447,30.0609074 L42.3654639,31.7556518 L44.2165183,36.8832195 C44.8871036,38.7407942 43.8961991,40.7812225 42.0032711,41.4406436 C40.1103431,42.1000648 38.032205,41.1287694 37.3616196,39.2711947 L35.4675311,34.024419 L26.0117426,37.1344786 L27.8536846,42.2368042 C28.52427,44.0943789 27.5333655,46.1348072 25.6404375,46.7942284 C23.7475095,47.4536495 21.6693713,46.4823542 20.998786,44.6247795 L19.1138098,39.4032458 L13.1700265,41.3581881 C11.2658783,41.9844726 9.20500808,40.9770567 8.56694401,39.1080616 C7.92887993,37.2390665 8.9552439,35.2162426 10.8593921,34.5899581 L16.6845594,32.6740292 L13.5146903,23.8932401 L7.79248973,25.7753026 C5.88834155,26.4015872 3.82747133,25.3941713 3.18940726,23.5251762 C2.55134319,21.6561811 3.57770715,19.6333572 5.48185533,19.0070726 L11.0854399,17.1640235 L8.90238232,11.1167805 C8.23179697,9.25920583 9.22270147,7.21877755 11.1156295,6.55935639 C13.0085575,5.89993524 15.0866956,6.8712306 15.757281,8.72880529 L17.9833728,14.8952564 Z",
	                id: "Combined-Shape",
	                fill: "#2C2C46"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var unlimited = exports.unlimited = function unlimited(_ref8) {
	  var style = _ref8.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "99px",
	      height: "87px",
	      viewBox: "0 0 99 87",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-714.000000, -511.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-49", transform: "translate(714.000000, 511.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-31-Copy-2" },
	            _react2.default.createElement("path", {
	              d: "M25.0645741,5.43917134 L27.9525354,4.625 L27.9525354,4.625 C41.0010932,0.946362859 54.8114509,0.93782051 67.8645495,4.60031256 L71.0102679,5.48295116 L71.0102679,5.48295116 C81.582847,8.44944884 89.8885386,16.6418119 93,27.1726402 L93.0258856,27.2602507 L93.0258856,27.2602507 C96.2722096,38.2475255 96.2632181,49.9403711 93,60.9226402 L93,60.9226402 L93,60.9226402 C89.8879801,71.3960558 81.6173858,79.5386618 71.0967123,82.4869721 L67.7942257,83.4124599 L67.7942257,83.4124599 C54.7548943,87.0665981 40.9603379,87.0536362 27.9278967,83.375 L24.8136814,82.4959579 L24.8136814,82.4959579 C14.3436989,79.5406208 6.11353066,71.4341412 3,61.0101076 L3,61.0101076 L3,61.0101076 C-0.263211178,50.0849468 -0.288590526,38.4479633 2.926936,27.5086729 L3,27.2601076 L3,27.2601076 C6.11138763,16.6750999 14.4456731,8.4328419 25.0645741,5.43917134 Z",
	              id: "Rectangle-19-Copy-9",
	              fill: "#B6BFF3"
	            }),
	            _react2.default.createElement("path", {
	              d: "M28.3359163,5.40165426 C18.0481585,8.30196926 9.97377203,16.2871981 6.95941088,26.5421196 L6.88634688,26.7906849 C3.72535777,37.5444378 3.75030667,48.9840505 6.95817167,59.7239135 C9.97371351,69.8198827 17.9448625,77.6712357 28.0853344,80.5335626 L31.1995497,81.4126047 C44.0549737,85.0412747 57.6621612,85.0540605 70.5243818,81.4495558 L73.8268684,80.524068 C84.016726,77.6684655 92.0272568,69.7818985 95.0414212,59.6378127 C98.2495601,48.840911 98.2583999,37.3454265 95.0668699,26.5436036 L95.0409843,26.4559931 C92.0269945,16.2550602 83.9814922,8.3193363 73.7401165,5.44576902 L70.5943981,4.56313042 C57.7183933,0.950328074 44.0954033,0.958754527 31.2238777,4.58748292 L28.3359163,5.40165426 Z",
	              id: "Rectangle-19-Copy-10",
	              stroke: "#222232",
	              strokeWidth: "2"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { id: "Group-41", transform: "translate(24.000000, 26.000000)" },
	            _react2.default.createElement("path", {
	              d: "M6.5775,30.735 C4.54082315,29.3483264 3.02417165,27.5608443 2.0275,25.3725 C1.03082835,23.1841557 0.5325,20.8550123 0.5325,18.385 C0.5325,15.9149876 1.03082835,13.5858443 2.0275,11.3975 C3.02417165,9.20915572 4.54082315,7.4216736 6.5775,6.035 C8.61417685,4.6483264 11.1058186,3.955 14.0525,3.955 C16.652513,3.955 18.8949906,4.63749317 20.78,6.0025 C22.6650094,7.36750682 24.5824902,9.3066541 26.5325,11.82 C28.4391762,9.34998765 30.3349906,7.4216736 32.22,6.035 C34.1050094,4.6483264 36.3258206,3.955 38.8825,3.955 C41.8725149,3.955 44.3858231,4.6483264 46.4225,6.035 C48.4591768,7.4216736 49.9758284,9.20915572 50.9725,11.3975 C51.9691717,13.5858443 52.4675,15.9149876 52.4675,18.385 C52.4675,20.8550123 51.9691717,23.1841557 50.9725,25.3725 C49.9758284,27.5608443 48.4591768,29.3483264 46.4225,30.735 C44.3858231,32.1216736 41.8941814,32.815 38.9475,32.815 C36.347487,32.815 34.0941762,32.14334 32.1875,30.8 C30.2808238,29.4566599 28.3741762,27.5716788 26.4675,25.145 C24.6041574,27.5716788 22.7191762,29.4566599 20.8125,30.8 C18.9058238,32.14334 16.652513,32.815 14.0525,32.815 C11.1058186,32.815 8.61417685,32.1216736 6.5775,30.735 Z M18.5375,22.675 C19.88084,21.2883264 20.8991632,19.9016736 21.5925,18.515 C20.8124961,17.0416593 19.7616733,15.5900071 18.44,14.16 C17.1183267,12.7299928 15.7208407,12.015 14.2475,12.015 C12.7741593,12.015 11.506672,12.5891609 10.445,13.7375 C9.38332802,14.8858391 8.8525,16.4349902 8.8525,18.385 C8.8525,20.3350097 9.38332802,21.8841609 10.445,23.0325 C11.506672,24.1808391 12.7741593,24.755 14.2475,24.755 C15.7641742,24.755 17.1941599,24.0616736 18.5375,22.675 Z M42.49,23.0325 C43.551672,21.8841609 44.0825,20.3350097 44.0825,18.385 C44.0825,16.4349902 43.551672,14.8858391 42.49,13.7375 C41.428328,12.5891609 40.1825071,12.015 38.7525,12.015 C37.2358258,12.015 35.7950068,12.7408261 34.43,14.1925 C33.0649932,15.6441739 32.0358368,17.0849928 31.3425,18.515 C32.0791704,19.9016736 33.11916,21.2883264 34.4625,22.675 C35.8058401,24.0616736 37.2358258,24.755 38.7525,24.755 C40.1825071,24.755 41.428328,24.1808391 42.49,23.0325 Z",
	              id: "\u221E",
	              fill: "#9192C5"
	            }),
	            _react2.default.createElement("path", {
	              d: "M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z",
	              id: "\u221E",
	              fill: "#F7F7F9"
	            }),
	            _react2.default.createElement("path", {
	              d: "M8.5775,27.735 C6.54082315,26.3483264 5.02417165,24.5608443 4.0275,22.3725 C3.03082835,20.1841557 2.5325,17.8550123 2.5325,15.385 C2.5325,12.9149876 3.03082835,10.5858443 4.0275,8.3975 C5.02417165,6.20915572 6.54082315,4.4216736 8.5775,3.035 C10.6141769,1.6483264 13.1058186,0.955 16.0525,0.955 C18.652513,0.955 20.8949906,1.63749317 22.78,3.0025 C24.6650094,4.36750682 26.5824902,6.3066541 28.5325,8.82 C30.4391762,6.34998765 32.3349906,4.4216736 34.22,3.035 C36.1050094,1.6483264 38.3258206,0.955 40.8825,0.955 C43.8725149,0.955 46.3858231,1.6483264 48.4225,3.035 C50.4591768,4.4216736 51.9758284,6.20915572 52.9725,8.3975 C53.9691717,10.5858443 54.4675,12.9149876 54.4675,15.385 C54.4675,17.8550123 53.9691717,20.1841557 52.9725,22.3725 C51.9758284,24.5608443 50.4591768,26.3483264 48.4225,27.735 C46.3858231,29.1216736 43.8941814,29.815 40.9475,29.815 C38.347487,29.815 36.0941762,29.14334 34.1875,27.8 C32.2808238,26.4566599 30.3741762,24.5716788 28.4675,22.145 C26.6041574,24.5716788 24.7191762,26.4566599 22.8125,27.8 C20.9058238,29.14334 18.652513,29.815 16.0525,29.815 C13.1058186,29.815 10.6141769,29.1216736 8.5775,27.735 Z M20.5375,19.675 C21.88084,18.2883264 22.8991632,16.9016736 23.5925,15.515 C22.8124961,14.0416593 21.7616733,12.5900071 20.44,11.16 C19.1183267,9.72999285 17.7208407,9.015 16.2475,9.015 C14.7741593,9.015 13.506672,9.58916092 12.445,10.7375 C11.383328,11.8858391 10.8525,13.4349902 10.8525,15.385 C10.8525,17.3350097 11.383328,18.8841609 12.445,20.0325 C13.506672,21.1808391 14.7741593,21.755 16.2475,21.755 C17.7641742,21.755 19.1941599,21.0616736 20.5375,19.675 Z M44.49,20.0325 C45.551672,18.8841609 46.0825,17.3350097 46.0825,15.385 C46.0825,13.4349902 45.551672,11.8858391 44.49,10.7375 C43.428328,9.58916092 42.1825071,9.015 40.7525,9.015 C39.2358258,9.015 37.7950068,9.74082607 36.43,11.1925 C35.0649932,12.6441739 34.0358368,14.0849928 33.3425,15.515 C34.0791704,16.9016736 35.11916,18.2883264 36.4625,19.675 C37.8058401,21.0616736 39.2358258,21.755 40.7525,21.755 C42.1825071,21.755 43.428328,21.1808391 44.49,20.0325 Z",
	              id: "\u221E",
	              stroke: "#222232",
	              strokeWidth: "2"
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var Sample2 = exports.Sample2 = function Sample2(_ref9) {
	  var style = _ref9.style;
	  return _react2.default.createElement("svg", { style: style });
	};
	
	var Sample3 = exports.Sample3 = function Sample3(_ref10) {
	  var style = _ref10.style;
	  return _react2.default.createElement("svg", { style: style });
	};

/***/ }),

/***/ "./src/assets/FillIcons.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.docs = exports.location = exports.money = exports.phone = exports.edit = exports.world = exports.website = exports.profile = exports.code = exports.frowney = exports.smiley = exports.slack = exports.unlimited = exports.install = exports.message = exports.analytics = exports.channels = exports.customize = exports.settings = exports.autoMessages = exports.clock = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clock = exports.clock = function clock(_ref) {
	  var style = _ref.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "49px",
	      height: "46px",
	      viewBox: "0 0 49 46",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-73.000000, -288.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-18-Copy-3", transform: "translate(73.000000, 289.000000)" },
	          _react2.default.createElement("ellipse", {
	            id: "Oval-12",
	            fill: "#B6BFF3",
	            cx: "22",
	            cy: "23.5",
	            rx: "22",
	            ry: "21.5"
	          }),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "Group-23",
	              transform: "translate(15.000000, 15.000000)",
	              stroke: "#9192C5",
	              strokeWidth: "4",
	              strokeLinecap: "round" },
	            _react2.default.createElement("path", {
	              d: "M14,4 L14,12",
	              id: "Line",
	              transform: "translate(14.000000, 8.000000) scale(1, -1) rotate(-45.000000) translate(-14.000000, -8.000000) "
	            }),
	            _react2.default.createElement("path", {
	              d: "M-0.48959236,6.01040764 L12.5104076,6.01040764",
	              id: "Line",
	              transform: "translate(6.010408, 6.010408) scale(1, -1) rotate(-45.000000) translate(-6.010408, -6.010408) "
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "clock",
	              transform: "translate(4.000000, 0.000000)",
	              stroke: "#222232",
	              strokeWidth: "2" },
	            _react2.default.createElement("path", {
	              d: "M26.4617559,18.0035425 L26.4617559,26.6035425",
	              id: "Line",
	              strokeLinecap: "round",
	              transform: "translate(26.461756, 22.303543) scale(1, -1) rotate(-45.000000) translate(-26.461756, -22.303543) "
	            }),
	            _react2.default.createElement("path", {
	              d: "M10.6034384,19.7667597 L24.6834384,19.7667597",
	              id: "Line",
	              strokeLinecap: "round",
	              transform: "translate(17.643438, 19.766760) scale(1, -1) rotate(-45.000000) translate(-17.643438, -19.766760) "
	            }),
	            _react2.default.createElement("ellipse", { id: "Oval-8", cx: "22", cy: "21.5", rx: "22", ry: "21.5" })
	          )
	        )
	      )
	    )
	  );
	};
	
	var autoMessages = exports.autoMessages = function autoMessages(_ref2) {
	  var style = _ref2.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "64px",
	      height: "49px",
	      viewBox: "0 0 64 49",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-141.000000, -289.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-22", transform: "translate(141.000000, 290.000000)" },
	          _react2.default.createElement("ellipse", {
	            id: "Oval-11",
	            fill: "#9192C5",
	            cx: "20.5",
	            cy: "19",
	            rx: "20.5",
	            ry: "18"
	          }),
	          _react2.default.createElement("path", {
	            d: "M11.9995947,40 L18.022421,36.0761035 C20.058443,36.6878675 22.2363762,37.0191304 24.5,37.0191304 C35.8218374,37.0191304 45,28.7321158 45,18.5095652 C45,8.28701461 35.8218374,0 24.5,0 C22.9753566,0 21.4895874,0.150279875 20.059871,0.435329014 C16.0319188,1.2384004 12.44887,3.11116611 9.69486511,5.70678375 C8.76116213,6.58678796 7.92275315,7.54988 7.19460818,8.58254336 C5.17184446,11.4512496 4,14.8568452 4,18.5095652 C4,24.0337041 6.68019502,28.9926303 10.9305199,32.3840599",
	            id: "Combined-Shape",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round",
	            strokeLinejoin: "round"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-11",
	            fill: "#B6BFF3",
	            cx: "39.5",
	            cy: "25",
	            rx: "20.5",
	            ry: "18"
	          }),
	          _react2.default.createElement("path", {
	            d: "M29.9995947,47 L36.022421,43.0761035 C38.058443,43.6878675 40.2363762,44.0191304 42.5,44.0191304 C53.8218374,44.0191304 63,35.7321158 63,25.5095652 C63,15.2870146 53.8218374,7 42.5,7 C40.9753566,7 39.4895874,7.15027988 38.059871,7.43532901 C34.0319188,8.2384004 30.44887,10.1111661 27.6948651,12.7067838 C26.7611621,13.586788 25.9227532,14.54988 25.1946082,15.5825434 C23.1718445,18.4512496 22,21.8568452 22,25.5095652 C22,31.0337041 24.680195,35.9926303 28.9305199,39.3840599",
	            id: "Combined-Shape-Copy-2",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round",
	            strokeLinejoin: "round",
	            transform: "translate(42.500000, 27.000000) scale(-1, 1) translate(-42.500000, -27.000000) "
	          })
	        )
	      )
	    )
	  );
	};
	
	var settings = exports.settings = function settings(_ref3) {
	  var style = _ref3.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "52px",
	      height: "50px",
	      viewBox: "0 0 52 50",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-224.000000, -289.000000)" },
	        _react2.default.createElement(
	          "g",
	          {
	            id: "Group-36",
	            transform: "translate(249.233495, 315.018982) rotate(-330.000000) translate(-249.233495, -315.018982) translate(225.233495, 290.018982)" },
	          _react2.default.createElement("path", {
	            d: "M11.8426851,10.4514068 C12.9164539,9.68545901 14.0717327,9.02457347 15.2931701,8.48395323 L16.180869,4.73613063 L16.180869,4.73613063 C16.3945235,3.83409169 17.2000265,3.19709129 18.127023,3.19709129 L28.4232067,3.19709129 L28.4232067,3.19709129 C29.3502032,3.19709129 30.1557063,3.83409169 30.3693607,4.73613063 L31.2570596,8.48395323 C32.4784971,9.02457347 33.6337759,9.68545901 34.7075447,10.4514068 L38.4743647,9.3231232 C39.3623806,9.05713391 40.3167907,9.4362198 40.7802889,10.2390223 L45.9283808,19.155779 C46.391879,19.9585815 46.242972,20.9746678 45.5686106,21.6107174 L42.7604648,24.2593272 C42.8243527,24.8968779 42.8570624,25.543511 42.8570624,26.19771 C42.8570624,26.851909 42.8243527,27.4985421 42.7604648,28.1360928 L45.5686106,30.7847026 C46.242972,31.4207522 46.391879,32.4368385 45.9283808,33.239641 L40.7802889,42.1563977 C40.3167907,42.9592002 39.3623806,43.3382861 38.4743647,43.0722968 L34.7075447,41.9440132 C33.6337759,42.709961 32.4784971,43.3708465 31.2570596,43.9114668 L30.3693607,47.6592894 C30.1557063,48.5613283 29.3502032,49.1983287 28.4232067,49.1983287 L18.127023,49.1983287 C17.2000265,49.1983287 16.3945235,48.5613283 16.180869,47.6592894 L15.2931701,43.9114668 C14.0717327,43.3708465 12.9164539,42.709961 11.8426851,41.9440132 L8.075865,43.0722968 C7.18784914,43.3382861 6.23343909,42.9592002 5.76994085,42.1563977 L0.621848984,33.239641 C0.158350745,32.4368385 0.307257758,31.4207522 0.981619166,30.7847026 L3.789765,28.1360928 C3.72587701,27.4985421 3.69316737,26.851909 3.69316737,26.19771 C3.69316737,25.543511 3.72587701,24.8968779 3.789765,24.2593272 L0.981619166,21.6107174 C0.307257758,20.9746678 0.158350745,19.9585815 0.621848984,19.155779 L5.76994085,10.2390223 L5.76994085,10.2390223 C6.23343909,9.4362198 7.18784914,9.05713391 8.075865,9.3231232 L8.075865,9.3231232 L11.8426851,10.4514068 Z M23.2751149,40.1784782 C31.0718391,40.1784782 37.3923328,33.9190751 37.3923328,26.19771 C37.3923328,18.4763449 31.0718391,12.2169418 23.2751149,12.2169418 C15.4783907,12.2169418 9.1578969,18.4763449 9.1578969,26.19771 C9.1578969,33.9190751 15.4783907,40.1784782 23.2751149,40.1784782 Z",
	            id: "Combined-Shape",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M13.5682427,7.25431554 C14.6420115,6.48836771 15.7972903,5.82748218 17.0187277,5.28686194 L17.9064267,1.53903934 L17.9064267,1.53903934 C18.1200811,0.637000403 18.9255842,-1.14182685e-13 19.8525806,-1.14352972e-13 L19.8525806,-1.13686838e-13 L30.1487644,-1.13686838e-13 C31.0757609,-1.13033786e-13 31.8812639,0.637000403 32.0949183,1.53903934 L32.9826173,5.28686194 C34.2040547,5.82748218 35.3593335,6.48836771 36.4331023,7.25431554 L40.1999224,6.1260319 L40.1999224,6.1260319 C41.0879382,5.86004262 42.0423483,6.23912851 42.5058465,7.04193101 L42.5058465,7.04193101 L47.6539384,15.9586877 C48.1174366,16.7614902 47.9685296,17.7775765 47.2941682,18.4136261 L44.4860224,21.0622359 C44.5499104,21.6997866 44.58262,22.3464197 44.58262,23.0006187 C44.58262,23.6548177 44.5499104,24.3014508 44.4860224,24.9390015 L47.2941682,27.5876113 C47.9685296,28.2236609 48.1174366,29.2397472 47.6539384,30.0425497 L47.6539384,30.0425497 L42.5058465,38.9593064 C42.0423483,39.7621089 41.0879382,40.1411948 40.1999224,39.8752055 L36.4331023,38.7469219 C35.3593335,39.5128697 34.2040547,40.1737552 32.9826173,40.7143755 L32.0949183,44.4621981 C31.8812639,45.364237 31.0757609,46.0012374 30.1487644,46.0012374 L19.8525806,46.0012374 C18.9255842,46.0012374 18.1200811,45.364237 17.9064267,44.4621981 L17.0187277,40.7143755 C15.7972903,40.1737552 14.6420115,39.5128697 13.5682427,38.7469219 L9.80142263,39.8752055 C8.91340677,40.1411948 7.95899672,39.7621089 7.49549848,38.9593064 L2.34740661,30.0425497 C1.88390837,29.2397472 2.03281538,28.2236609 2.70717679,27.5876113 L2.70717679,27.5876113 L5.51532263,24.9390015 C5.45143464,24.3014508 5.41872499,23.6548177 5.41872499,23.0006187 C5.41872499,22.3464197 5.45143464,21.6997866 5.51532263,21.0622359 L2.70717679,18.4136261 C2.03281538,17.7775765 1.88390837,16.7614902 2.34740661,15.9586877 L7.49549848,7.04193101 L7.49549848,7.04193101 C7.95899672,6.23912851 8.91340677,5.86004262 9.80142263,6.1260319 L9.80142263,6.1260319 L13.5682427,7.25431554 Z M25.0006725,36.9813869 C32.7973967,36.9813869 39.1178905,30.7219838 39.1178905,23.0006187 C39.1178905,15.2792536 32.7973967,9.01985047 25.0006725,9.01985047 C17.2039483,9.01985047 10.8834545,15.2792536 10.8834545,23.0006187 C10.8834545,30.7219838 17.2039483,36.9813869 25.0006725,36.9813869 Z",
	            id: "Combined-Shape",
	            stroke: "#222232",
	            strokeWidth: "2"
	          })
	        )
	      )
	    )
	  );
	};
	
	var customize = exports.customize = function customize(_ref4) {
	  var style = _ref4.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "53px",
	      height: "33px",
	      viewBox: "0 0 53 33",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-296.000000, -299.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-43", transform: "translate(297.000000, 300.000000)" },
	          _react2.default.createElement("path", {
	            d: "M49.1976919,23.3333333 L1.848333,23.3333333",
	            id: "Line-13-Copy-3",
	            stroke: "#B6BFF3",
	            strokeWidth: "5",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M49.2419052,6.66666667 L1.86477783,6.66666667",
	            id: "Line-13-Copy-5",
	            stroke: "#B6BFF3",
	            strokeWidth: "5",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M46.0136189,25.1734882 L20.9268977,25.1734882",
	            id: "Line-13-Copy-3",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M32,8.51335745 L7.21611053,8.51335745",
	            id: "Line-13-Copy-5",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-9",
	            fill: "#F7F7F9",
	            cx: "15.995913",
	            cy: "6.01709402",
	            rx: "6",
	            ry: "6.01709402"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-9",
	            fill: "#9192C5",
	            cx: "13.995913",
	            cy: "8.01709402",
	            rx: "6",
	            ry: "6.01709402"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-9",
	            stroke: "#222232",
	            strokeWidth: "2",
	            cx: "15.995913",
	            cy: "6.01709402",
	            rx: "6",
	            ry: "6.01709402"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-11",
	            fill: "#F7F7F9",
	            cx: "36.8989149",
	            cy: "23.6772247",
	            rx: "6",
	            ry: "6.01709402"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-11",
	            fill: "#9192C5",
	            cx: "34.8989149",
	            cy: "25.6772247",
	            rx: "6",
	            ry: "6.01709402"
	          }),
	          _react2.default.createElement("ellipse", {
	            id: "Oval-13-Copy-11",
	            stroke: "#222232",
	            strokeWidth: "2",
	            cx: "36.8989149",
	            cy: "23.6772247",
	            rx: "6",
	            ry: "6.01709402"
	          })
	        )
	      )
	    )
	  );
	};
	
	var channels = exports.channels = function channels(_ref5) {
	  var style = _ref5.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "67px",
	      height: "49px",
	      viewBox: "0 0 67 49",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-375.000000, -290.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-17", transform: "translate(374.000000, 288.000000)" },
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#9192C5" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "0.5", y: "17" },
	              "#"
	            )
	          ),
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#222232" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "1.5", y: "17" },
	              "#"
	            )
	          ),
	          _react2.default.createElement("path", {
	            d: "M20.5,9 L47.0188612,9",
	            id: "Line-15",
	            stroke: "#9192C5",
	            strokeWidth: "8",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M21.5,12.5 L40.5,12.5",
	            id: "Line-16",
	            stroke: "#222232",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#-copy-2",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#EBECEF" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "0.5", y: "53" },
	              "#"
	            )
	          ),
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#-copy-2",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#9192C5" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "1.5", y: "53" },
	              "#"
	            )
	          ),
	          _react2.default.createElement("path", {
	            d: "M20.5,45 L55,45",
	            id: "Line-15-Copy-2",
	            stroke: "#B6BFF3",
	            strokeWidth: "8",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M21.5,48.5 L40.5,48.5",
	            id: "Line-16-Copy",
	            stroke: "#222232",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#-copy",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#EBECEF" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "0.5", y: "35" },
	              "#"
	            )
	          ),
	          _react2.default.createElement(
	            "text",
	            {
	              id: "#-copy",
	              fontFamily: "Rubik-Bold, Rubik",
	              fontSize: "18",
	              fontWeight: "bold",
	              fill: "#9192C5" },
	            _react2.default.createElement(
	              "tspan",
	              { x: "1.5", y: "35" },
	              "#"
	            )
	          ),
	          _react2.default.createElement("path", {
	            d: "M20.5,27 L64,27",
	            id: "Line-15-Copy-3",
	            stroke: "#B6BFF3",
	            strokeWidth: "8",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M21.5,30.5 L56.5142828,30.5",
	            id: "Line-16-Copy-2",
	            stroke: "#222232",
	            strokeLinecap: "round"
	          })
	        )
	      )
	    )
	  );
	};
	
	var analytics = exports.analytics = function analytics(_ref6) {
	  var style = _ref6.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "57px",
	      height: "37px",
	      viewBox: "0 0 57 37",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "defs",
	      null,
	      _react2.default.createElement("rect", { id: "path-1", x: "0", y: "0", width: "50", height: "30", rx: "3" })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-450.000000, -300.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-49", transform: "translate(450.000000, 302.000000)" },
	          _react2.default.createElement("rect", {
	            id: "Rectangle-46-Copy",
	            fill: "#9192C5",
	            x: "0",
	            y: "2",
	            width: "52",
	            height: "33",
	            rx: "3"
	          }),
	          _react2.default.createElement(
	            "g",
	            { id: "Path-4", transform: "translate(5.000000, 0.000000)" },
	            _react2.default.createElement(
	              "mask",
	              { id: "mask-2", fill: "white" },
	              _react2.default.createElement("use", { xlinkHref: "#path-1" })
	            ),
	            _react2.default.createElement(
	              "g",
	              { id: "Mask" },
	              _react2.default.createElement("use", { fill: "#F7F7F9", fillRule: "evenodd", xlinkHref: "#path-1" }),
	              _react2.default.createElement("rect", {
	                stroke: "#222232",
	                strokeWidth: "2",
	                x: "-1",
	                y: "-1",
	                width: "52",
	                height: "32",
	                rx: "3"
	              })
	            ),
	            _react2.default.createElement("path", {
	              d: "M-0.0354848548,27.4543128 L6.48604047,15.9520492 L6.48604047,15.9520492 C7.03083322,14.9911774 8.25141551,14.6538787 9.21228732,15.1986714 C9.2169643,15.2013232 9.22163057,15.2039938 9.22628601,15.2066831 L13.9878913,17.9573855 L13.9878913,17.9573855 C15.5105636,18.8370087 17.4291289,18.6190236 18.7156531,17.4202227 L25.7840854,10.8337605 L25.7840854,10.8337605 C26.3845987,10.2741941 27.2660393,10.1383489 28.0071635,10.4911459 L33.8274283,13.2617644 L33.8274283,13.2617644 C35.0537638,13.8455364 36.4925402,13.7671411 37.6481874,13.053581 L51.5971122,4.44074734 L51.5971122,28.4407473 L51.5971122,28.4407473 C51.5971122,29.5453168 50.7016817,30.4407473 49.5971122,30.4407473 L1.70432746,30.4407473 L1.70432746,30.4407473 C0.599757963,30.4407473 -0.295672538,29.5453168 -0.295672538,28.4407473 C-0.295672538,28.0949726 -0.206026927,27.7551044 -0.0354848548,27.4543128 Z",
	              fill: "#B6BFF3",
	              mask: "url(#mask-2)"
	            })
	          ),
	          _react2.default.createElement("path", {
	            d: "M7.87137396,27.8238957 L14.5185876,19.4438253 L14.5185876,19.4438253 C14.761045,19.1381619 15.1591323,19.0014172 15.5382412,19.09357 L22.0267816,20.6707859 L22.0267816,20.6707859 C22.6236831,20.815879 23.254152,20.6786225 23.7367164,20.2985237 L31.4724202,14.2053865 L31.4724202,14.2053865 C31.6487632,14.0664874 31.8667117,13.9909601 32.0911884,13.9909601 L41.4689714,13.9909601 L41.4689714,13.9909601 C42.0131639,13.9909601 42.5338596,13.769206 42.9109545,13.3768478 L50.9684127,4.99325539",
	            id: "Path-4",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          })
	        )
	      )
	    )
	  );
	};
	
	var message = exports.message = function message(_ref7) {
	  var style = _ref7.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "53px",
	      height: "33px",
	      viewBox: "0 0 53 33",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-524.000000, -300.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-29", transform: "translate(524.000000, 300.000000)" },
	          _react2.default.createElement("rect", {
	            id: "Rectangle-46",
	            fill: "#9192C5",
	            x: "0",
	            y: "3",
	            width: "50",
	            height: "30",
	            rx: "3"
	          }),
	          _react2.default.createElement("rect", {
	            id: "Rectangle-46",
	            fill: "#F7F7F9",
	            x: "3",
	            y: "0",
	            width: "50",
	            height: "30",
	            rx: "3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M11,9.44489025 L27.2620537,21.6018665 L27.2620537,21.6018665 C28.0032007,22.1559236 29.0276557,22.1292097 29.7389196,21.5372791 L45,8.83664952",
	            id: "Path-20-Copy",
	            stroke: "#9192C5",
	            strokeWidth: "2",
	            strokeLinecap: "round",
	            strokeLinejoin: "round",
	            transform: "translate(28.000000, 15.418325) scale(1, -1) translate(-28.000000, -15.418325) "
	          }),
	          _react2.default.createElement("path", {
	            d: "M12,7.22352328 L26.7820124,16.8010869 L26.7820124,16.8010869 C27.4669224,17.2448539 28.3527594,17.2279623 29.0202537,16.7584069 L50,2",
	            id: "Path-20",
	            stroke: "#222232",
	            strokeWidth: "2",
	            fill: "#F7F7F9",
	            strokeLinecap: "round",
	            strokeLinejoin: "round"
	          }),
	          _react2.default.createElement("rect", {
	            id: "Rectangle-46",
	            stroke: "#222232",
	            strokeWidth: "2",
	            x: "4",
	            y: "1",
	            width: "48",
	            height: "28",
	            rx: "3"
	          })
	        )
	      )
	    )
	  );
	};
	
	var install = exports.install = function install(_ref8) {
	  var style = _ref8.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "56px",
	      height: "46px",
	      viewBox: "0 0 56 46",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-597.000000, -296.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-4", transform: "translate(597.000000, 296.000000)" },
	          _react2.default.createElement("path", {
	            d: "M15.9974211,34 C12.5202958,34 10.6761942,34 10.4651163,34 C4.68539215,34 0,29.4333044 0,23.8 C0,18.5446844 4.07771713,14.2176433 9.31754155,13.6606241 C9.30743571,13.4527649 9.30232558,13.2436307 9.30232558,13.0333333 C9.30232558,5.83522209 15.2892156,0 22.6744186,0 C30.0596217,0 36.0465116,5.83522209 36.0465116,13.0333333 C36.0465116,13.2231978 36.0423463,13.4121141 36.0340998,13.6 L39.5348837,13.6 C45.3146078,13.6 50,18.1666956 50,23.8 C50,29.4333044 45.3146078,34 39.5348837,34 L32.5970609,34",
	            id: "Combined-Shape",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M16.4651163,33 L38.5970609,33 L45.5348837,33 C50.7679844,33 55,28.8751954 55,23.8 C55,18.7248046 50.7679844,14.6 45.5348837,14.6 L40.9892461,14.6 L41.0350616,13.5561513 C41.0426876,13.3824019 41.0465116,13.2081052 41.0465116,13.0333333 C41.0465116,6.39333111 35.5129982,1 28.6744186,1 C21.835839,1 16.3023256,6.39333111 16.3023256,13.0333333 C16.3023256,13.2268598 16.3070143,13.4198024 16.3163618,13.6120629 L16.362216,14.5552046 L15.4232508,14.6550212 C10.6463897,15.1628251 7,19.1008001 7,23.8 C7,28.8751954 11.2320156,33 16.4651163,33 Z",
	            id: "Combined-Shape",
	            stroke: "#222232",
	            strokeWidth: "2"
	          }),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "forward",
	              transform: "translate(29.500000, 37.000000) rotate(-270.000000) translate(-29.500000, -37.000000) translate(21.000000, 30.000000)",
	              strokeLinecap: "round",
	              stroke: "#222232" },
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group",
	                transform: "translate(8.925000, 7.000000) scale(-1, 1) translate(-8.925000, -7.000000) translate(1.700000, 0.000000)" },
	              _react2.default.createElement("path", {
	                d: "M3.60624458,5.4623106 L3.60624458,14.2123106",
	                id: "Line-Copy",
	                strokeWidth: "2",
	                transform: "translate(3.606245, 9.837311) rotate(-225.000000) translate(-3.606245, -9.837311) "
	              }),
	              _react2.default.createElement("path", {
	                d: "M-0.643755416,3.7123106 L7.85624458,3.7123106",
	                id: "Line-Copy-2",
	                strokeWidth: "2",
	                transform: "translate(3.606245, 3.712311) rotate(-225.000000) translate(-3.606245, -3.712311) "
	              }),
	              _react2.default.createElement("path", { d: "M1.7,7 L14.45,7", id: "Line-7-Copy", strokeWidth: "2" })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var unlimited = exports.unlimited = function unlimited(_ref9) {
	  var style = _ref9.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "50px",
	      height: "30px",
	      viewBox: "0 0 50 30",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-671.000000, -300.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-41-Copy", transform: "translate(671.000000, 301.000000)" },
	          _react2.default.createElement("path", {
	            d: "M5.47058824,27.1261261 C3.62744176,25.8768706 2.25490647,24.2665264 1.35294118,22.295045 C0.450975882,20.3235637 0,18.2252364 0,16 C0,13.7747636 0.450975882,11.6764363 1.35294118,9.70495495 C2.25490647,7.73347363 3.62744176,6.12312937 5.47058824,4.87387387 C7.31373471,3.62461838 9.56861412,3 12.2352941,3 C14.5882471,3 16.6176385,3.61485872 18.3235294,4.84459459 C20.0294203,6.07433047 21.7646971,7.82131 23.5294118,10.0855856 C25.2549106,7.86034923 26.9705797,6.12312937 28.6764706,4.87387387 C30.3823615,3.62461838 32.3921453,3 34.7058824,3 C37.4117782,3 39.6862653,3.62461838 41.5294118,4.87387387 C43.3725582,6.12312937 44.7450935,7.73347363 45.6470588,9.70495495 C46.5490241,11.6764363 47,13.7747636 47,16 C47,18.2252364 46.5490241,20.3235637 45.6470588,22.295045 C44.7450935,24.2665264 43.3725582,25.8768706 41.5294118,27.1261261 C39.6862653,28.3753816 37.4313859,29 34.7647059,29 C32.4117529,29 30.3725576,28.3949009 28.6470588,27.1846847 C26.92156,25.9744684 25.1960871,24.2762872 23.4705882,22.0900901 C21.7843053,24.2762872 20.07844,25.9744684 18.3529412,27.1846847 C16.6274424,28.3949009 14.5882471,29 12.2352941,29 C9.56861412,29 7.31373471,28.3753816 5.47058824,27.1261261 Z M16.2941176,19.8648649 C17.50981,18.6156094 18.4313694,17.3663726 19.0588235,16.1171171 C18.3529376,14.7897832 17.4019668,13.4819884 16.2058824,12.1936937 C15.0097979,10.905399 13.7451047,10.2612613 12.4117647,10.2612613 C11.0784247,10.2612613 9.93137735,10.7785234 8.97058824,11.8130631 C8.00979912,12.8476028 7.52941176,14.2432345 7.52941176,16 C7.52941176,17.7567655 8.00979912,19.1523972 8.97058824,20.1869369 C9.93137735,21.2214766 11.0784247,21.7387387 12.4117647,21.7387387 C13.7843206,21.7387387 15.0784253,21.1141204 16.2941176,19.8648649 Z M37.9705882,20.1869369 C38.9313774,19.1523972 39.4117647,17.7567655 39.4117647,16 C39.4117647,14.2432345 38.9313774,12.8476028 37.9705882,11.8130631 C37.0097991,10.7785234 35.8823594,10.2612613 34.5882353,10.2612613 C33.2156794,10.2612613 31.9117709,10.9151586 30.6764706,12.222973 C29.4411703,13.5307873 28.5098071,14.8288224 27.8823529,16.1171171 C28.5490229,17.3663726 29.49019,18.6156094 30.7058824,19.8648649 C31.9215747,21.1141204 33.2156794,21.7387387 34.5882353,21.7387387 C35.8823594,21.7387387 37.0097991,21.2214766 37.9705882,20.1869369 Z",
	            id: "\u221E",
	            fill: "#9192C5"
	          }),
	          _react2.default.createElement("path", {
	            d: "M7.47058824,24.1261261 C5.62744176,22.8768706 4.25490647,21.2665264 3.35294118,19.295045 C2.45097588,17.3235637 2,15.2252364 2,13 C2,10.7747636 2.45097588,8.67643628 3.35294118,6.70495495 C4.25490647,4.73347363 5.62744176,3.12312937 7.47058824,1.87387387 C9.31373471,0.624618378 11.5686141,0 14.2352941,0 C16.5882471,0 18.6176385,0.614858716 20.3235294,1.84459459 C22.0294203,3.07433047 23.7646971,4.82131 25.5294118,7.08558559 C27.2549106,4.86034923 28.9705797,3.12312937 30.6764706,1.87387387 C32.3823615,0.624618378 34.3921453,0 36.7058824,0 C39.4117782,0 41.6862653,0.624618378 43.5294118,1.87387387 C45.3725582,3.12312937 46.7450935,4.73347363 47.6470588,6.70495495 C48.5490241,8.67643628 49,10.7747636 49,13 C49,15.2252364 48.5490241,17.3235637 47.6470588,19.295045 C46.7450935,21.2665264 45.3725582,22.8768706 43.5294118,24.1261261 C41.6862653,25.3753816 39.4313859,26 36.7647059,26 C34.4117529,26 32.3725576,25.3949009 30.6470588,24.1846847 C28.92156,22.9744684 27.1960871,21.2762872 25.4705882,19.0900901 C23.7843053,21.2762872 22.07844,22.9744684 20.3529412,24.1846847 C18.6274424,25.3949009 16.5882471,26 14.2352941,26 C11.5686141,26 9.31373471,25.3753816 7.47058824,24.1261261 Z M18.2941176,16.8648649 C19.50981,15.6156094 20.4313694,14.3663726 21.0588235,13.1171171 C20.3529376,11.7897832 19.4019668,10.4819884 18.2058824,9.19369369 C17.0097979,7.90539896 15.7451047,7.26126126 14.4117647,7.26126126 C13.0784247,7.26126126 11.9313774,7.77852336 10.9705882,8.81306306 C10.0097991,9.84760277 9.52941176,11.2432345 9.52941176,13 C9.52941176,14.7567655 10.0097991,16.1523972 10.9705882,17.1869369 C11.9313774,18.2214766 13.0784247,18.7387387 14.4117647,18.7387387 C15.7843206,18.7387387 17.0784253,18.1141204 18.2941176,16.8648649 Z M39.9705882,17.1869369 C40.9313774,16.1523972 41.4117647,14.7567655 41.4117647,13 C41.4117647,11.2432345 40.9313774,9.84760277 39.9705882,8.81306306 C39.0097991,7.77852336 37.8823594,7.26126126 36.5882353,7.26126126 C35.2156794,7.26126126 33.9117709,7.91515863 32.6764706,9.22297297 C31.4411703,10.5307873 30.5098071,11.8288224 29.8823529,13.1171171 C30.5490229,14.3663726 31.49019,15.6156094 32.7058824,16.8648649 C33.9215747,18.1141204 35.2156794,18.7387387 36.5882353,18.7387387 C37.8823594,18.7387387 39.0097991,18.2214766 39.9705882,17.1869369 Z",
	            id: "\u221E",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M7.47058824,24.1261261 C5.62744176,22.8768706 4.25490647,21.2665264 3.35294118,19.295045 C2.45097588,17.3235637 2,15.2252364 2,13 C2,10.7747636 2.45097588,8.67643628 3.35294118,6.70495495 C4.25490647,4.73347363 5.62744176,3.12312937 7.47058824,1.87387387 C9.31373471,0.624618378 11.5686141,0 14.2352941,0 C16.5882471,0 18.6176385,0.614858716 20.3235294,1.84459459 C22.0294203,3.07433047 23.7646971,4.82131 25.5294118,7.08558559 C27.2549106,4.86034923 28.9705797,3.12312937 30.6764706,1.87387387 C32.3823615,0.624618378 34.3921453,0 36.7058824,0 C39.4117782,0 41.6862653,0.624618378 43.5294118,1.87387387 C45.3725582,3.12312937 46.7450935,4.73347363 47.6470588,6.70495495 C48.5490241,8.67643628 49,10.7747636 49,13 C49,15.2252364 48.5490241,17.3235637 47.6470588,19.295045 C46.7450935,21.2665264 45.3725582,22.8768706 43.5294118,24.1261261 C41.6862653,25.3753816 39.4313859,26 36.7647059,26 C34.4117529,26 32.3725576,25.3949009 30.6470588,24.1846847 C28.92156,22.9744684 27.1960871,21.2762872 25.4705882,19.0900901 C23.7843053,21.2762872 22.07844,22.9744684 20.3529412,24.1846847 C18.6274424,25.3949009 16.5882471,26 14.2352941,26 C11.5686141,26 9.31373471,25.3753816 7.47058824,24.1261261 Z M18.2941176,16.8648649 C19.50981,15.6156094 20.4313694,14.3663726 21.0588235,13.1171171 C20.3529376,11.7897832 19.4019668,10.4819884 18.2058824,9.19369369 C17.0097979,7.90539896 15.7451047,7.26126126 14.4117647,7.26126126 C13.0784247,7.26126126 11.9313774,7.77852336 10.9705882,8.81306306 C10.0097991,9.84760277 9.52941176,11.2432345 9.52941176,13 C9.52941176,14.7567655 10.0097991,16.1523972 10.9705882,17.1869369 C11.9313774,18.2214766 13.0784247,18.7387387 14.4117647,18.7387387 C15.7843206,18.7387387 17.0784253,18.1141204 18.2941176,16.8648649 Z M39.9705882,17.1869369 C40.9313774,16.1523972 41.4117647,14.7567655 41.4117647,13 C41.4117647,11.2432345 40.9313774,9.84760277 39.9705882,8.81306306 C39.0097991,7.77852336 37.8823594,7.26126126 36.5882353,7.26126126 C35.2156794,7.26126126 33.9117709,7.91515863 32.6764706,9.22297297 C31.4411703,10.5307873 30.5098071,11.8288224 29.8823529,13.1171171 C30.5490229,14.3663726 31.49019,15.6156094 32.7058824,16.8648649 C33.9215747,18.1141204 35.2156794,18.7387387 36.5882353,18.7387387 C37.8823594,18.7387387 39.0097991,18.2214766 39.9705882,17.1869369 Z",
	            id: "\u221E",
	            stroke: "#222232",
	            strokeWidth: "2"
	          })
	        )
	      )
	    )
	  );
	};
	
	var slack = exports.slack = function slack(_ref10) {
	  var style = _ref10.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "42px",
	      height: "41px",
	      viewBox: "0 0 42 41",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "icon-system",
	          transform: "translate(-732.000000, -291.000000)",
	          fillRule: "nonzero" },
	        _react2.default.createElement(
	          "g",
	          { id: "slack", transform: "translate(732.880952, 290.475000)" },
	          _react2.default.createElement("path", {
	            d: "M14.278351,20.1920678 L16.8776436,27.3923149 L24.6313901,24.842066 L22.0320975,17.6418189 L14.278351,20.1920678 Z M12.2863657,14.6741102 L20.0401122,12.1238613 L18.2574771,7.18582054 C17.7075971,5.66260929 18.5201388,3.98945809 20.0723398,3.44873274 C21.6245407,2.9080074 23.328614,3.70446959 23.878494,5.22768084 L25.6964171,10.2634722 L30.2005783,8.7820294 C31.7619798,8.26847606 33.4518934,9.09455712 33.9751059,10.6271331 C34.4983185,12.1597091 33.6567,13.8184247 32.0952985,14.331978 L27.6884024,15.7814298 L30.2876951,22.9816769 L34.6101584,21.5599954 C36.1715599,21.0464421 37.8614735,21.8725232 38.384686,23.4050992 C38.9078986,24.9376751 38.0662801,26.5963907 36.5048786,27.109944 L32.2796804,28.4996345 L33.797545,32.70424 C34.347425,34.2274512 33.5348833,35.9006024 31.9826823,36.4413278 C30.4304814,36.9820531 28.7264081,36.1855909 28.1765281,34.6623797 L26.6233755,30.3600236 L18.869629,32.9102725 L20.3800214,37.0941795 C20.9299014,38.6173907 20.1173597,40.2905419 18.5651587,40.8312673 C17.0129578,41.3719926 15.3088845,40.5755304 14.7590045,39.0523192 L13.213324,34.7706615 L8.33942171,36.3737142 C6.7780202,36.8872676 5.08810662,36.0611865 4.56489408,34.5286105 C4.04168155,32.9960345 4.88329999,31.337319 6.4447015,30.8237656 L11.2213387,29.252704 L8.62204608,22.0524569 L3.92984158,23.5957482 C2.36844007,24.1093015 0.678526493,23.2832205 0.155313954,21.7506445 C-0.367898584,20.2180685 0.473719864,18.5593529 2.03512137,18.0457996 L6.63006075,16.5344993 L4.83995351,11.57576 C4.29007352,10.0525488 5.1026152,8.37939759 6.65481616,7.83867224 C8.20701712,7.2979469 9.91109042,8.09440909 10.4609704,9.61762034 L12.2863657,14.6741102 Z",
	            id: "Combined-Shape",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M16.738351,17.7320678 L19.3376436,24.9323149 L27.0913901,22.382066 L24.4920975,15.1818189 L16.738351,17.7320678 Z M14.7463657,12.2141102 L22.5001122,9.66386132 L20.7174771,4.72582054 C20.1675971,3.20260929 20.9801388,1.52945809 22.5323398,0.988732745 C24.0845407,0.448007399 25.788614,1.24446959 26.338494,2.76768084 L28.1564171,7.80347223 L32.6605783,6.3220294 C34.2219798,5.80847606 35.9118934,6.63455712 36.4351059,8.16713311 C36.9583185,9.6997091 36.1167,11.3584247 34.5552985,11.871978 L30.1484024,13.3214298 L32.7476951,20.5216769 L37.0701584,19.0999954 C38.6315599,18.5864421 40.3214735,19.4125232 40.844686,20.9450992 C41.3678986,22.4776751 40.5262801,24.1363907 38.9648786,24.649944 L34.7396804,26.0396345 L36.257545,30.24424 C36.807425,31.7674512 35.9948833,33.4406024 34.4426823,33.9813278 C32.8904814,34.5220531 31.1864081,33.7255909 30.6365281,32.2023797 L29.0833755,27.9000236 L21.329629,30.4502725 L22.8400214,34.6341795 C23.3899014,36.1573907 22.5773597,37.8305419 21.0251587,38.3712673 C19.4729578,38.9119926 17.7688845,38.1155304 17.2190045,36.5923192 L15.673324,32.3106615 L10.7994217,33.9137142 C9.2380202,34.4272676 7.54810662,33.6011865 7.02489408,32.0686105 C6.50168155,30.5360345 7.34329999,28.877319 8.9047015,28.3637656 L13.6813387,26.792704 L11.0820461,19.5924569 L6.38984158,21.1357482 C4.82844007,21.6493015 3.13852649,20.8232205 2.61531395,19.2906445 C2.09210142,17.7580685 2.93371986,16.0993529 4.49512137,15.5857996 L9.09006075,14.0744993 L7.29995351,9.11576004 C6.75007352,7.59254878 7.5626152,5.91939759 9.11481616,5.37867224 C10.6670171,4.8379469 12.3710904,5.63440909 12.9209704,7.15762034 L14.7463657,12.2141102 Z",
	            id: "Combined-Shape",
	            fill: "#2C2C46"
	          })
	        )
	      )
	    )
	  );
	};
	
	var smiley = exports.smiley = function smiley(_ref11) {
	  var style = _ref11.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "43px",
	      height: "41px",
	      viewBox: "0 0 43 41",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-787.000000, -293.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-25", transform: "translate(787.000000, 294.000000)" },
	          _react2.default.createElement("ellipse", {
	            id: "Oval-12",
	            fill: "#B6BFF3",
	            cx: "19.5",
	            cy: "21",
	            rx: "19.5",
	            ry: "19"
	          }),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "smiley",
	              transform: "translate(4.000000, 0.000000)",
	              stroke: "#222232" },
	            _react2.default.createElement("circle", { id: "Oval-8-Copy-3", strokeWidth: "2", cx: "19", cy: "19", r: "19" }),
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-15",
	                strokeWidth: "1",
	                fillRule: "evenodd",
	                transform: "translate(7.600000, 10.640000)" },
	              _react2.default.createElement("path", {
	                d: "M11.4,21.28 C17.6960461,21.28 22.8,15.8357826 22.8,9.12 C22.8,9.12 17.1,12.0798257 11.4,12.0798257 C5.7,12.0798257 0,9.12 0,9.12 C0,15.8357826 5.10395385,21.28 11.4,21.28 Z",
	                id: "Oval-8-Copy-5",
	                strokeWidth: "2",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M6.84,0 L6.84,3.04",
	                id: "Line-Copy-5",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M15.96,0 L15.96,3.04",
	                id: "Line-Copy-6",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var frowney = exports.frowney = function frowney(_ref12) {
	  var style = _ref12.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "43px",
	      height: "41px",
	      viewBox: "0 0 43 41",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-787.000000, -343.000000)" },
	        _react2.default.createElement(
	          "g",
	          {
	            id: "Group-25-Copy",
	            transform: "translate(808.000000, 364.000000) scale(1, -1) translate(-808.000000, -364.000000) translate(787.000000, 344.000000)" },
	          _react2.default.createElement("ellipse", {
	            id: "Oval-12",
	            fill: "#FC8C9C",
	            cx: "19.5",
	            cy: "19",
	            rx: "19.5",
	            ry: "19"
	          }),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "smiley",
	              transform: "translate(4.000000, 2.000000)",
	              stroke: "#222232" },
	            _react2.default.createElement("circle", { id: "Oval-8-Copy-3", strokeWidth: "2", cx: "19", cy: "19", r: "19" }),
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-15",
	                strokeWidth: "1",
	                fillRule: "evenodd",
	                transform: "translate(7.600000, 10.640000)" },
	              _react2.default.createElement("path", {
	                d: "M11.4,21.28 C17.6960461,21.28 22.8,15.8357826 22.8,9.12 C22.8,9.12 17.1,12.0798257 11.4,12.0798257 C5.7,12.0798257 0,9.12 0,9.12 C0,15.8357826 5.10395385,21.28 11.4,21.28 Z",
	                id: "Oval-8-Copy-5",
	                strokeWidth: "2",
	                strokeLinejoin: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M6.84,0 L6.84,3.04",
	                id: "Line-Copy-5",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M15.96,0 L15.96,3.04",
	                id: "Line-Copy-6",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var code = exports.code = function code(_ref13) {
	  var style = _ref13.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "43px",
	      height: "29px",
	      viewBox: "0 0 43 29",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      {
	        id: "Page-1",
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd",
	        strokeLinecap: "round" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "icon-system",
	          transform: "translate(-843.000000, -299.000000)",
	          stroke: "#222232" },
	        _react2.default.createElement(
	          "g",
	          { id: "code", transform: "translate(843.000000, 298.000000)" },
	          _react2.default.createElement(
	            "g",
	            {
	              id: "check-copy-2",
	              transform: "translate(21.500000, 15.500000) rotate(-15.000000) translate(-21.500000, -15.500000) translate(13.437500, 2.695652)" },
	            _react2.default.createElement("path", {
	              d: "M1.20869632,24.7443871 L14.6461963,1.39935452",
	              id: "Line",
	              strokeWidth: "2"
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "back-copy-2",
	              transform: "translate(36.281250, 15.500000) scale(-1, 1) translate(-36.281250, -15.500000) translate(29.562500, 4.043478)" },
	            _react2.default.createElement("path", {
	              d: "M6.71875,9.43478261 L6.71875,22.9130435",
	              id: "Line",
	              strokeWidth: "2",
	              transform: "translate(6.718750, 16.173913) rotate(-225.000000) translate(-6.718750, -16.173913) "
	            }),
	            _react2.default.createElement("path", {
	              d: "M0,6.73913043 L13.4375,6.73913043",
	              id: "Line",
	              strokeWidth: "2",
	              transform: "translate(6.718750, 6.739130) rotate(-225.000000) translate(-6.718750, -6.739130) "
	            })
	          ),
	          _react2.default.createElement(
	            "g",
	            { id: "back-copy-2", transform: "translate(0.000000, 4.043478)" },
	            _react2.default.createElement("path", {
	              d: "M6.71875,9.43478261 L6.71875,22.9130435",
	              id: "Line",
	              strokeWidth: "2",
	              transform: "translate(6.718750, 16.173913) rotate(-225.000000) translate(-6.718750, -16.173913) "
	            }),
	            _react2.default.createElement("path", {
	              d: "M0,6.73913043 L13.4375,6.73913043",
	              id: "Line",
	              strokeWidth: "2",
	              transform: "translate(6.718750, 6.739130) rotate(-225.000000) translate(-6.718750, -6.739130) "
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var profile = exports.profile = function profile(_ref14) {
	  var style = _ref14.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "28px",
	      height: "34px",
	      viewBox: "0 0 28 34",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-896.000000, -296.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-19-Copy", transform: "translate(896.000000, 297.000000)" },
	          _react2.default.createElement("path", {
	            d: "M18,7.5 C18,11.0898571 15.0898571,14 11.5,14 C7.91014286,14 5,11.0898571 5,7.5 C5,3.91014286 7.91014286,1 11.5,1 C15.0898571,1 18,3.91014286 18,7.5",
	            id: "Fill-1",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M16.6189437,17.0772579 C15.2671861,17.9702138 13.6876883,18.4835137 12,18.4835137 C10.3122424,18.4835137 8.73281385,17.9702138 7.38105628,17.0772579 C7.24252814,16.9857041 7.07290043,16.9760265 6.924329,17.0455366 C2.85575758,18.9483485 0,23.4126672 0,28.6167124 L0,30.5347319 C0,31.8962862 0.995324675,33 2.22309957,33 L21.7769004,33 C23.0046753,33 24,31.8962862 24,30.5347319 L24,28.6167124 C24,23.4126672 21.1441732,18.9483485 17.0756017,17.0455366 C16.9270303,16.9760265 16.7574719,16.9857041 16.6189437,17.0772579 Z",
	            id: "Fill-3",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M21,6.5 C21,10.0898571 18.0898571,13 14.5,13 C10.9101429,13 8,10.0898571 8,6.5 C8,2.91014286 10.9101429,0 14.5,0 C18.0898571,0 21,2.91014286 21,6.5",
	            id: "Fill-1",
	            stroke: "#222232",
	            strokeWidth: "2"
	          }),
	          _react2.default.createElement("path", {
	            d: "M19.6189437,16.0772579 C18.2671861,16.9702138 16.6876883,17.4835137 15,17.4835137 C13.3122424,17.4835137 11.7328139,16.9702138 10.3810563,16.0772579 C10.2425281,15.9857041 10.0729004,15.9760265 9.924329,16.0455366 C5.85575758,17.9483485 3,22.4126672 3,27.6167124 L3,29.5347319 C3,30.8962862 3.99532468,32 5.22309957,32 L24.7769004,32 C26.0046753,32 27,30.8962862 27,29.5347319 L27,27.6167124 C27,22.4126672 24.1441732,17.9483485 20.0756017,16.0455366 C19.9270303,15.9760265 19.7574719,15.9857041 19.6189437,16.0772579 Z",
	            id: "Fill-3",
	            stroke: "#222232",
	            strokeWidth: "2"
	          })
	        )
	      )
	    )
	  );
	};
	
	var website = exports.website = function website(_ref15) {
	  var style = _ref15.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "54px",
	      height: "42px",
	      viewBox: "0 0 54 42",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-930.000000, -292.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-53", transform: "translate(931.000000, 293.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-32-Copy-2" },
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-28-Copy",
	                transform: "translate(20.000000, 13.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -13.000000) " },
	              _react2.default.createElement("rect", {
	                id: "Rectangle-45",
	                fill: "#B6BFF3",
	                x: "2.5",
	                y: "3.55271368e-15",
	                width: "37.5",
	                height: "22.7272727",
	                rx: "3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M8.8817842e-16,7.81818182 L8.8817842e-16,22.474076 L8.8817842e-16,22.474076 C1.82687564e-15,24.1309303 1.34314575,25.474076 3,25.474076 L30.7003701,25.474076",
	                id: "Path-19",
	                stroke: "#222232",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              })
	            ),
	            _react2.default.createElement("rect", {
	              id: "Rectangle-11",
	              fill: "#9192C5",
	              x: "11",
	              y: "6",
	              width: "23",
	              height: "4",
	              rx: "2"
	            }),
	            _react2.default.createElement("circle", { id: "Oval-14", fill: "#F7F7F9", cx: "7", cy: "8", r: "2" })
	          ),
	          _react2.default.createElement(
	            "g",
	            { id: "Group-32-Copy-3", transform: "translate(13.000000, 15.000000)" },
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-28-Copy",
	                transform: "translate(20.000000, 13.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -13.000000) " },
	              _react2.default.createElement("rect", {
	                id: "Rectangle-45",
	                fill: "#B6BFF3",
	                x: "2.5",
	                y: "3.55271368e-15",
	                width: "37.5",
	                height: "22.7272727",
	                rx: "3"
	              }),
	              _react2.default.createElement("path", {
	                d: "M8.8817842e-16,7.81818182 L8.8817842e-16,22.474076 L8.8817842e-16,22.474076 C1.82687564e-15,24.1309303 1.34314575,25.474076 3,25.474076 L30.7003701,25.474076",
	                id: "Path-19",
	                stroke: "#222232",
	                strokeWidth: "2",
	                strokeLinecap: "round"
	              }),
	              _react2.default.createElement("path", {
	                d: "M26.8580542,2.51515152 L26.8580542,11.3682479 L26.8580542,11.3682479 C26.8580542,13.0251021 28.2011999,14.3682479 29.8580542,14.3682479 L37.4503701,14.3682479",
	                id: "Path-19-Copy",
	                stroke: "#222232",
	                strokeWidth: "2",
	                strokeLinecap: "round",
	                transform: "translate(32.154212, 8.441700) scale(-1, -1) translate(-32.154212, -8.441700) "
	              })
	            ),
	            _react2.default.createElement("rect", {
	              id: "Rectangle-11",
	              fill: "#9192C5",
	              x: "11",
	              y: "6",
	              width: "23",
	              height: "4",
	              rx: "2"
	            }),
	            _react2.default.createElement("circle", { id: "Oval-14", fill: "#F7F7F9", cx: "7", cy: "8", r: "2" })
	          )
	        )
	      )
	    )
	  );
	};
	
	var world = exports.world = function world(_ref16) {
	  var style = _ref16.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "39px",
	      height: "38px",
	      viewBox: "0 0 39 38",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1000.000000, -294.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Icon-Outlines", transform: "translate(41.000000, 61.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-54", transform: "translate(959.000000, 234.000000)" },
	            _react2.default.createElement(
	              "g",
	              { id: "Group-5-Copy-3", transform: "translate(0.000000, 1.000000)" },
	              _react2.default.createElement("circle", { id: "Oval-8", fill: "#B6BFF3", cx: "17.5", cy: "18.5", r: "17.5" }),
	              _react2.default.createElement(
	                "g",
	                {
	                  id: "Group-2",
	                  transform: "translate(3.600000, 0.000000)",
	                  fill: "#F7F7F9" },
	                _react2.default.createElement("path", {
	                  d: "M5.53134481,4.73453223 C5.53134481,4.73453223 6.53308172,6.55434628 8.06297702,6.06778519 C9.59287233,5.58122409 12.2282374,3.323399 13.6027152,5.59776366 C14.977193,7.87212831 13.3131506,7.49346927 11.0747714,11.321827 C10.2606929,12.7141664 11.9118964,15.7703733 11.5118702,17.939819 C11.4000984,18.5459863 10.3330245,18.4573907 9.80392046,18.2139801 C8.6284871,17.6732302 7.96185765,15.3542547 6.73519531,15.7423433 C4.5656244,16.4287472 5.58476889,23.4623073 7.51536227,23.6858732 C8.70050842,23.8231151 9.94620047,22.8080253 11.0747714,22.3961159 C17.0247716,20.2244653 12.8540777,27.3715295 12.9249989,28.4941378 C13.0016198,29.706965 15.1836328,31.2389786 14.4380244,33.3060085 C14.1665529,34.0586017 2.21239546,31.0887957 0.492079924,20.523539 C-1.22823561,9.95828232 5.53134481,4.73453223 5.53134481,4.73453223 Z",
	                  id: "Path-5"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M23.6234283,0.342001884 C26.3710475,4.62231684 24.6784733,9.58781154 20.7110596,10.271618 C18.8064132,10.5998947 18.4162309,16.0379418 19.9237934,20.1842381 C21.093409,23.4010684 26.5149045,15.2242422 27.3244806,19.3127187 C28.3231594,24.3561911 18.9579767,27.1422259 26.211349,31.2 C26.211349,31.2 37.3266726,24.3684674 33.6498149,11.6636107 C29.9729571,-1.04124609 23.6234283,0.342001884 23.6234283,0.342001884 Z",
	                  id: "Path-6"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-5-Copy-3",
	                transform: "translate(3.000000, 0.000000)",
	                stroke: "#222232",
	                strokeWidth: "2" },
	              _react2.default.createElement("circle", { id: "Oval-8", cx: "17.5", cy: "17.5", r: "17.5" }),
	              _react2.default.createElement(
	                "g",
	                { id: "Group-2", transform: "translate(5.600000, 0.000000)" },
	                _react2.default.createElement("path", {
	                  d: "M-8.8817842e-16,6.03194913 C-8.8817842e-16,6.03194913 1.53308172,7.55434628 3.06297702,7.06778519 C4.59287233,6.58122409 7.22823739,4.323399 8.60271519,6.59776366 C9.97719299,8.87212831 8.31315064,8.49346927 6.07477138,12.321827 C5.26069285,13.7141664 6.91189641,16.7703733 6.51187018,18.939819 C6.4000984,19.5459863 5.33302447,19.4573907 4.80392046,19.2139801 C3.6284871,18.6732302 2.96185765,16.3542547 1.73519531,16.7423433 C-0.434375604,17.4287472 0.584768891,24.4623073 2.51536227,24.6858732 C3.70050842,24.8231151 4.94620047,23.8080253 6.07477138,23.3961159 C12.0247716,21.2244653 7.85407766,28.3715295 7.92499892,29.4941378 C8.00161979,30.706965 10.1836328,32.2389786 9.43802445,34.3060085",
	                  id: "Path-5"
	                }),
	                _react2.default.createElement("path", {
	                  d: "M18.6234283,1.34200188 C21.3710475,5.62231684 19.6784733,10.5878115 15.7110596,11.271618 C13.8064132,11.5998947 13.4162309,17.0379418 14.9237934,21.1842381 C16.093409,24.4010684 21.5149045,16.2242422 22.3244806,20.3127187 C23.3231594,25.3561911 13.9579767,28.1422259 21.211349,32.2",
	                  id: "Path-6"
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var edit = exports.edit = function edit(_ref17) {
	  var style = _ref17.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "41px",
	      height: "38px",
	      viewBox: "0 0 41 38",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1056.000000, -293.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-30", transform: "translate(1056.000000, 292.000000)" },
	          _react2.default.createElement("ellipse", {
	            id: "Oval-11-Copy-2",
	            fill: "#B6BFF3",
	            cx: "17",
	            cy: "20.5",
	            rx: "17",
	            ry: "14.5"
	          }),
	          _react2.default.createElement("path", {
	            d: "M9.63381026,38 L14.6283491,34.8608828 C16.3167576,35.350294 18.1228485,35.6153043 20,35.6153043 C29.3888407,35.6153043 37,28.9856926 37,20.8076521 C37,12.6296117 29.3888407,6 20,6 C18.7356616,6 17.5035603,6.1202239 16.3179418,6.34826321 C12.9776887,6.99072032 10.00638,8.48893289 7.72257106,10.565427 C6.94828079,11.2694304 6.25301481,12.039904 5.64918727,12.8660347 C3.97177345,15.1609996 3,17.8854762 3,20.8076521 C3,25.2269633 5.22260074,29.1941043 8.74726043,31.9072479",
	            id: "Combined-Shape-Copy-5",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round",
	            strokeLinejoin: "round",
	            transform: "translate(20.000000, 22.000000) scale(-1, 1) translate(-20.000000, -22.000000) "
	          }),
	          _react2.default.createElement("path", {
	            d: "M28.0147643,0.188866509 L28.644017,0.137022328 L28.644017,0.137022328 C30.2952763,0.000974961316 31.7441746,1.22929689 31.880222,2.88055614 C31.8833867,2.91896787 31.8858109,2.95743701 31.8874933,2.99594216 L32.5483089,18.1205282 L29.6458368,23.1801076 L29.6458368,23.1801076 C29.3710218,23.6591641 28.7598882,23.8247346 28.2808317,23.5499196 C28.1333791,23.4653322 28.0099237,23.3445519 27.9221268,23.1989875 L25.8358942,19.7400805 L25.8358942,19.7400805 C25.45984,19.1165947 25.2610998,18.4022897 25.2610998,17.6741748 L25.2610998,3.17873587 L25.2610998,3.17873587 C25.2610998,1.61739049 26.4586914,0.317071466 28.0147643,0.188866509 Z",
	            id: "Rectangle-9",
	            fill: "#9192C5",
	            transform: "translate(28.904704, 11.904704) rotate(-315.000000) translate(-28.904704, -11.904704) "
	          }),
	          _react2.default.createElement(
	            "g",
	            {
	              id: "pencil",
	              transform: "translate(19.000000, 0.000000)",
	              stroke: "#222232" },
	            _react2.default.createElement(
	              "g",
	              {
	                id: "Group-7-Copy",
	                transform: "translate(11.376163, 11.376163) rotate(-225.000000) translate(-11.376163, -11.376163) translate(-0.945265, 8.090449)" },
	              _react2.default.createElement("rect", {
	                id: "Rectangle-19",
	                strokeWidth: "2",
	                x: "4.72693262",
	                y: "1",
	                width: "13.5288859",
	                height: "4.21155436"
	              }),
	              _react2.default.createElement("path", {
	                d: "M19.6388858,5.21155436 L22.9783408,3.24051124 C23.2695447,3.06863428 23.269714,3.10646103 22.9691888,2.92914171 L19.6996314,1 L3.10932042,1 C1.95260845,1 1.0124365,1.9426207 1.0124365,3.10577718 C1.0124365,4.26640055 1.95792999,5.21155436 3.12174158,5.21155436 L19.6388858,5.21155436 Z",
	                id: "Rectangle-19-Copy-2",
	                strokeWidth: "2"
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var phone = exports.phone = function phone(_ref18) {
	  var style = _ref18.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "29px",
	      height: "43px",
	      viewBox: "0 0 29 43",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "defs",
	      null,
	      _react2.default.createElement("rect", { id: "path-1", x: "3", y: "0", width: "26", height: "41", rx: "3" })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1111.000000, -292.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "phone-copy", transform: "translate(1111.000000, 292.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-51" },
	            _react2.default.createElement("path", {
	              d: "M3,2 L27,2 L27,40 L27,40 C27,41.6568542 25.6568542,43 24,43 L3,43 L3,43 C1.34314575,43 2.02906125e-16,41.6568542 0,40 L0,5 L0,5 C-2.02906125e-16,3.34314575 1.34314575,2 3,2 Z",
	              id: "Rectangle-51",
	              fill: "#9192C5"
	            }),
	            _react2.default.createElement(
	              "g",
	              { id: "Rectangle-51" },
	              _react2.default.createElement("use", { fill: "#B6BFF3", fillRule: "evenodd", xlinkHref: "#path-1" }),
	              _react2.default.createElement("rect", {
	                stroke: "#222232",
	                strokeWidth: "2",
	                x: "4",
	                y: "1",
	                width: "24",
	                height: "39",
	                rx: "3"
	              })
	            ),
	            _react2.default.createElement("circle", {
	              id: "Oval-10",
	              stroke: "#222232",
	              strokeWidth: "2",
	              cx: "16",
	              cy: "36",
	              r: "1"
	            })
	          ),
	          _react2.default.createElement("rect", {
	            id: "Rectangle-51",
	            fill: "#F7F7F9",
	            x: "6",
	            y: "3",
	            width: "20",
	            height: "30",
	            rx: "3"
	          })
	        )
	      )
	    )
	  );
	};
	
	var money = exports.money = function money(_ref19) {
	  var style = _ref19.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "31px",
	      height: "43px",
	      viewBox: "0 0 31 43",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1155.000000, -291.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-27", transform: "translate(1155.000000, 291.000000)" },
	          _react2.default.createElement("path", {
	            d: "M11.1311475,42.6733333 C10.9016382,42.4555545 10.7868852,42.1755573 10.7868852,41.8333333 L10.7868852,38.5666667 C8.4917918,38.2866653 6.54099164,37.7033378 4.93442623,36.8166667 C3.32786082,35.9299956 2.11912974,34.8333399 1.30819672,33.5266667 C0.497263705,32.2199935 0.0612024918,30.8355629 0,29.3733333 C0,29.0933319 0.0994525574,28.8600009 0.298360656,28.6733333 C0.497268754,28.4866657 0.734424852,28.3933333 1.00983607,28.3933333 L7.1147541,28.3933333 C7.5125703,28.3933333 7.81857816,28.4555549 8.03278689,28.58 C8.24699561,28.7044451 8.4918019,28.9222207 8.76721311,29.2333333 C9.71585174,30.944453 11.4600966,31.8 14,31.8 C15.6524673,31.8 16.9300501,31.5433359 17.8327869,31.03 C18.7355236,30.5166641 19.1868852,29.8088934 19.1868852,28.9066667 C19.1868852,28.2533301 18.9497291,27.7166688 18.4754098,27.2966667 C18.0010905,26.8766646 17.2666716,26.503335 16.2721311,26.1766667 C15.2775907,25.8499984 13.8164031,25.4844465 11.8885246,25.08 C8.18577384,24.3333296 5.41640262,23.1977854 3.58032787,21.6733333 C1.74425311,20.1488813 0.826229508,17.9711253 0.826229508,15.14 C0.826229508,12.6199874 1.71365233,10.4811199 3.48852459,8.72333333 C5.26339685,6.96554677 7.69615941,5.86889107 10.7868852,5.43333333 L10.7868852,2.16666667 C10.7868852,1.82444273 10.9016382,1.54444553 11.1311475,1.32666667 C11.3606569,1.1088878 11.6284138,1 11.9344262,1 L15.9278689,1 C16.2644826,1 16.5398896,1.1088878 16.7540984,1.32666667 C16.9683071,1.54444553 17.0754098,1.82444273 17.0754098,2.16666667 L17.0754098,5.52666667 C19.0950921,5.90000187 20.8393369,6.56110637 22.3081967,7.51 C23.7770565,8.45889363 24.9016354,9.54777163 25.6819672,10.7766667 C26.462299,12.0055617 26.8830598,13.1955498 26.9442623,14.3466667 C26.9442623,14.6266681 26.8524599,14.8677768 26.6688525,15.07 C26.485245,15.2722232 26.2557391,15.3733333 25.9803279,15.3733333 L19.5540984,15.3733333 C18.8502697,15.3733333 18.3300563,15.0933361 17.9934426,14.5333333 C17.8098351,13.8799967 17.3278728,13.32778 16.547541,12.8766667 C15.7672092,12.4255533 14.826235,12.2 13.7245902,12.2 C12.4393378,12.2 11.4448123,12.433331 10.7409836,12.9 C10.037155,13.366669 9.6852459,14.0511066 9.6852459,14.9533333 C9.6852459,15.8555601 10.1442577,16.5633308 11.0622951,17.0766667 C11.9803325,17.5900026 13.6786761,18.1111085 16.157377,18.64 C19.0338942,19.1688915 21.3289532,19.829996 23.042623,20.6233333 C24.7562927,21.4166706 26.010925,22.443327 26.8065574,23.7033333 C27.6021898,24.9633396 28,26.5577681 28,28.4866667 C28,31.2244581 27.0131246,33.4799911 25.0393443,35.2533333 C23.0655639,37.0266755 20.4109456,38.1311089 17.0754098,38.5666667 L17.0754098,41.8333333 C17.0754098,42.1755573 16.9683071,42.4555545 16.7540984,42.6733333 C16.5398896,42.8911122 16.2644826,43 15.9278689,43 L11.9344262,43 C11.6284138,43 11.3606569,42.8911122 11.1311475,42.6733333 Z",
	            id: "$",
	            fill: "#9192C5"
	          }),
	          _react2.default.createElement("path", {
	            d: "M14.1311475,41.6733333 C13.9016382,41.4555545 13.7868852,41.1755573 13.7868852,40.8333333 L13.7868852,37.5666667 C11.4917918,37.2866653 9.54099164,36.7033378 7.93442623,35.8166667 C6.32786082,34.9299956 5.11912974,33.8333399 4.30819672,32.5266667 C3.4972637,31.2199935 3.06120249,29.8355629 3,28.3733333 C3,28.0933319 3.09945256,27.8600009 3.29836066,27.6733333 C3.49726875,27.4866657 3.73442485,27.3933333 4.00983607,27.3933333 L10.1147541,27.3933333 C10.5125703,27.3933333 10.8185782,27.4555549 11.0327869,27.58 C11.2469956,27.7044451 11.4918019,27.9222207 11.7672131,28.2333333 C12.7158517,29.944453 14.4600966,30.8 17,30.8 C18.6524673,30.8 19.9300501,30.5433359 20.8327869,30.03 C21.7355236,29.5166641 22.1868852,28.8088934 22.1868852,27.9066667 C22.1868852,27.2533301 21.9497291,26.7166688 21.4754098,26.2966667 C21.0010905,25.8766646 20.2666716,25.503335 19.2721311,25.1766667 C18.2775907,24.8499984 16.8164031,24.4844465 14.8885246,24.08 C11.1857738,23.3333296 8.41640262,22.1977854 6.58032787,20.6733333 C4.74425311,19.1488813 3.82622951,16.9711253 3.82622951,14.14 C3.82622951,11.6199874 4.71365233,9.4811199 6.48852459,7.72333333 C8.26339685,5.96554677 10.6961594,4.86889107 13.7868852,4.43333333 L13.7868852,1.16666667 C13.7868852,0.824442733 13.9016382,0.544445533 14.1311475,0.326666667 C14.3606569,0.1088878 14.6284138,0 14.9344262,0 L18.9278689,0 C19.2644826,0 19.5398896,0.1088878 19.7540984,0.326666667 C19.9683071,0.544445533 20.0754098,0.824442733 20.0754098,1.16666667 L20.0754098,4.52666667 C22.0950921,4.90000187 23.8393369,5.56110637 25.3081967,6.51 C26.7770565,7.45889363 27.9016354,8.54777163 28.6819672,9.77666667 C29.462299,11.0055617 29.8830598,12.1955498 29.9442623,13.3466667 C29.9442623,13.6266681 29.8524599,13.8677768 29.6688525,14.07 C29.485245,14.2722232 29.2557391,14.3733333 28.9803279,14.3733333 L22.5540984,14.3733333 C21.8502697,14.3733333 21.3300563,14.0933361 20.9934426,13.5333333 C20.8098351,12.8799967 20.3278728,12.32778 19.547541,11.8766667 C18.7672092,11.4255533 17.826235,11.2 16.7245902,11.2 C15.4393378,11.2 14.4448123,11.433331 13.7409836,11.9 C13.037155,12.366669 12.6852459,13.0511066 12.6852459,13.9533333 C12.6852459,14.8555601 13.1442577,15.5633308 14.0622951,16.0766667 C14.9803325,16.5900026 16.6786761,17.1111085 19.157377,17.64 C22.0338942,18.1688915 24.3289532,18.829996 26.042623,19.6233333 C27.7562927,20.4166706 29.010925,21.443327 29.8065574,22.7033333 C30.6021898,23.9633396 31,25.5577681 31,27.4866667 C31,30.2244581 30.0131246,32.4799911 28.0393443,34.2533333 C26.0655639,36.0266755 23.4109456,37.1311089 20.0754098,37.5666667 L20.0754098,40.8333333 C20.0754098,41.1755573 19.9683071,41.4555545 19.7540984,41.6733333 C19.5398896,41.8911122 19.2644826,42 18.9278689,42 L14.9344262,42 C14.6284138,42 14.3606569,41.8911122 14.1311475,41.6733333 Z",
	            id: "$",
	            fill: "#B6BFF3"
	          }),
	          _react2.default.createElement("path", {
	            d: "M11.785,27.535014 C12.7150047,29.1783462 14.4249876,30 16.915,30 C18.5350081,30 19.7874956,29.7535039 20.6725,29.2605042 C21.5575044,28.7675045 22,28.0877728 22,27.2212885 C22,26.5938344 21.7675023,26.0784334 21.3025,25.67507 C20.8374977,25.2717067 20.1175049,24.9131668 19.1425,24.5994398 C18.1674951,24.2857127 16.7350095,23.9346425 14.845,23.5462185 C11.2149819,22.8291281 8.500009,21.7385694 6.7,20.2745098 C4.899991,18.8104502 4,16.7189678 4,14 M30,13 C30,13.2608709 29.9095754,13.4855063 29.7287234,13.673913 C29.5478714,13.8623198 29.3218099,13.9565217 29.0505319,13.9565217 L22.7207447,13.9565217 C22.0274788,13.9565217 21.5150726,13.6956548 21.1835106,13.173913 C21.0026587,12.5652143 20.5279294,12.0507267 19.7593085,11.6304348 C18.9906876,11.2101428 18.0638352,11 16.9787234,11 C15.7127596,11 14.7331595,11.2173891 14.0398936,11.6521739 C13.3466277,12.0869587 13,12.7246335 13,13.5652174 C13,14.4058013 13.4521231,15.065215 14.356383,15.5434783 C15.2606428,16.0217415 16.9334984,16.5072439 19.375,17 M14,37 C11.6595628,36.725887 9.67022096,36.1548267 8.03191489,35.286802 C6.39360883,34.4187774 5.16099704,33.3451841 4.33404255,32.0659898 C3.50708806,30.7867956 3.06241166,29.4314792 3,28",
	            id: "$-copy",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          })
	        )
	      )
	    )
	  );
	};
	
	var location = exports.location = function location(_ref20) {
	  var style = _ref20.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "30px",
	      height: "39px",
	      viewBox: "0 0 30 39",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1199.000000, -294.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-55", transform: "translate(1199.000000, 295.000000)" },
	          _react2.default.createElement(
	            "g",
	            { id: "Group-52" },
	            _react2.default.createElement("path", {
	              d: "M12.5,33 C15.1400087,33 25,21.657294 25,13.5714286 C25,5.48556315 19.4035594,1 12.5,1 C5.59644063,1 3.86809735e-16,5.48556315 0,13.5714286 C0,21.657294 9.8599913,33 12.5,33 Z",
	              id: "Oval-8-Copy-3",
	              fill: "#9192C5"
	            }),
	            _react2.default.createElement("path", {
	              d: "M16.5,32 C19.1400087,32 29,20.657294 29,12.5714286 C29,4.48556315 23.4035594,0 16.5,0 C9.59644063,0 4,4.48556315 4,12.5714286 C4,20.657294 13.8599913,32 16.5,32 Z",
	              id: "Oval-8-Copy-3",
	              stroke: "#222232",
	              strokeWidth: "2",
	              fill: "#B6BFF3"
	            }),
	            _react2.default.createElement("circle", {
	              id: "Oval-8-Copy-6",
	              fill: "#F7F7F9",
	              cx: "14.5",
	              cy: "10.5",
	              r: "4.5"
	            }),
	            _react2.default.createElement("circle", {
	              id: "Oval-8-Copy-6",
	              stroke: "#222232",
	              strokeWidth: "2",
	              cx: "16.5",
	              cy: "9.5",
	              r: "4.5"
	            })
	          ),
	          _react2.default.createElement("path", {
	            d: "M7.5,37 L25.5,37",
	            id: "Line-11",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          })
	        )
	      )
	    )
	  );
	};
	
	var docs = exports.docs = function docs(_ref21) {
	  var style = _ref21.style;
	  return _react2.default.createElement(
	    "svg",
	    {
	      style: style,
	      width: "36px",
	      height: "43px",
	      viewBox: "0 0 36 43",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      xmlnsXlink: "http://www.w3.org/1999/xlink" },
	    _react2.default.createElement(
	      "defs",
	      null,
	      _react2.default.createElement("rect", {
	        id: "path-1",
	        x: "2",
	        y: "5.69444444",
	        width: "26.1724138",
	        height: "34.1666667",
	        rx: "3"
	      })
	    ),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "icon-system", transform: "translate(-1241.000000, -290.000000)" },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-51", transform: "translate(1241.000000, 291.000000)" },
	          _react2.default.createElement("rect", {
	            id: "Rectangle-51",
	            fill: "#9192C5",
	            x: "7.05142629",
	            y: "2.69444444",
	            width: "24.1209875",
	            height: "31.6305346",
	            rx: "3"
	          }),
	          _react2.default.createElement("rect", {
	            id: "Rectangle-51",
	            fill: "#B6BFF3",
	            x: "0",
	            y: "7.69444444",
	            width: "26.1724138",
	            height: "34.1666667",
	            rx: "3"
	          }),
	          _react2.default.createElement(
	            "g",
	            { id: "Rectangle-51" },
	            _react2.default.createElement("use", { fill: "#F7F7F9", fillRule: "evenodd", xlinkHref: "#path-1" }),
	            _react2.default.createElement("rect", {
	              stroke: "#222232",
	              strokeWidth: "2",
	              x: "3",
	              y: "6.69444444",
	              width: "24.1724138",
	              height: "32.1666667",
	              rx: "3"
	            })
	          ),
	          _react2.default.createElement("path", {
	            d: "M8.25862069,12.5277778 L13.5042236,12.5277778",
	            id: "Line-20",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M8.25862069,19.3611111 L21.9611249,19.3611111",
	            id: "Line-20-Copy",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M8.25862069,23.9166667 L21.9611249,23.9166667",
	            id: "Line-20-Copy-2",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M8.25862069,28.4722222 L21.9611249,28.4722222",
	            id: "Line-20-Copy-3",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M8.25862069,33.0277778 L21.9611249,33.0277778",
	            id: "Line-20-Copy-4",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          }),
	          _react2.default.createElement("path", {
	            d: "M9.88987265,3.46469513 L9.88987265,3.46469513 L9.88987265,3.46469513 C9.88987265,1.87654227 11.1773249,0.589089993 12.7654778,0.589089993 L31.0108601,0.589089993 L31.0108601,0.589089993 C32.6677144,0.589089993 34.0108601,1.93223574 34.0108601,3.58908999 L34.0108601,29.629443 L34.0108601,29.629443 C34.0108601,31.0599608 32.8511963,32.2196246 31.4206785,32.2196246 L31.4206785,32.2196246",
	            id: "Path-21",
	            stroke: "#222232",
	            strokeWidth: "2",
	            strokeLinecap: "round"
	          })
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ "./src/assets/pngs/FeatureHeaderBackground.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FeatureHeaderBackground.0cd1b927.png";

/***/ }),

/***/ "./src/assets/pngs/SectionThreeBackground.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SectionThreeBackground.03206d0e.png";

/***/ }),

/***/ "./src/assets/pngs/bkg-am.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bkg-am.31ab661b.png";

/***/ }),

/***/ "./src/assets/pngs/bkg-customize.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bkg-customize.d4990be6.png";

/***/ }),

/***/ "./src/assets/svgs/SectionCalloutBackground.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/assets/svgs/autoMessage.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/autoMessage.a9dcb66f.svg";

/***/ }),

/***/ "./src/assets/svgs/customize.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/customize.beba2fdb.svg";

/***/ }),

/***/ "./src/assets/svgs/sideBySide.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sideBySide.941b5374.svg";

/***/ }),

/***/ "./src/assets/svgs/storefront.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/storefront.a913c8a9.svg";

/***/ }),

/***/ "./src/components/ArticleCard.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcon = __webpack_require__("./src/components/FeatureIcon.js");
	
	var _FeatureIcon2 = _interopRequireDefault(_FeatureIcon);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleCardsContainer = _styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardsContainer"
	})(["display:flex;justify-content:center;position:relative;width:100%;margin-top:50px;max-width:1200px;@media (max-width:768px){flex-direction:column;align-items:center;width:90%;margin-top:150px;margin-bottom:50px;}@media screen and (max-width:480px){width:100%;margin-top:20px;margin-bottom:50px;}"]);
	
	var ArticleCardWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardWrapper"
	})(["display:flex;align-items:center;overflow:hidden;justify-content:center;flex-direction:row;width:100%;max-width:500px;margin-right:20px;margin-left:0px;background-color:white;box-shadow:0px 5px 10px ", ";border-radius:12px;transition:300ms ease all;color:", ";&:nth-child(2){margin-right:0px;margin-left:20px;@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:0px;padding:5px;}@media (max-width:480px){width:100%;padding:5px;}}:hover{transform:translateY(-3px);box-shadow:0px 8px 20px ", ";}a{color:", ";display:block;height:90%;width:90%;}@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:30px;padding:5px;}@media (max-width:480px){margin-bottom:20px;width:100%;padding:5px;}"], _colors.SECONDARY_TEXT, _colors.PRIMARY_TEXT, _colors.SECONDARY_TEXT, _colors.ACTIVE_TEXT);
	
	var ArticleCardItemContent = _styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardItemContent"
	})(["display:flex;flex-direction:column;text-align:left;padding:15px 0px;padding-right:5px;margin-left:30px;width:100%;@media (max-width:768px){margin-left:35px;padding:10px 0px;}@media (max-width:615px){padding:5px 0px;}"]);
	
	var ArticleCardItemIcon = _styledComponents2.default.div.withConfig({
	  displayName: "ArticleCard__ArticleCardItemIcon"
	})(["transform:scale(1.7);width:30%;max-width:100px;position:relative;right:15px;flex-shrink:0;@media (max-width:768px){transform:scale(1.4);top:2px;width:20%;}@media (max-width:480px){transform:scale(0.8);right:30px;width:10%;}"]);
	
	var ArticleCardItemName = _styledComponents2.default.h4.withConfig({
	  displayName: "ArticleCard__ArticleCardItemName"
	})(["font-size:16px;@media (max-width:615px){font-size:14px;}"]);
	
	var ArticleCardItemDescription = _styledComponents2.default.p.withConfig({
	  displayName: "ArticleCard__ArticleCardItemDescription"
	})(["font-size:15px;line-height:21px;@media (max-width:768px){font-size:14px;line-height:19px;}@media (max-width:615px){font-size:13px;line-height:17px;}"]);
	
	var ArticleCardItemLink = _styledComponents2.default.a.withConfig({
	  displayName: "ArticleCard__ArticleCardItemLink"
	})(["font-size:15px;margin-right:20px;margin-left:0px;&:nth-child(2){margin-right:0px;margin-left:20px;@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:0px;padding:5px;}@media (max-width:480px){width:100%;padding:5px;}}@media (max-width:768px){margin-right:0px;margin-left:0px;margin-bottom:30px;padding:5px;}@media (max-width:615px){font-size:13px;margin-bottom:20px;width:100%;padding:5px;}"]);
	
	var ArticleCard = function ArticleCard(_ref) {
	  var articles = _ref.articles;
	
	  if (!articles || articles.length < 1) {
	    return null;
	  }
	  return _react2.default.createElement(
	    ArticleCardsContainer,
	    null,
	    articles.slice(0, 4).map(function (article, index, props) {
	      return _react2.default.createElement(
	        ArticleCardItemLink,
	        { href: article.articleLink },
	        _react2.default.createElement(
	          ArticleCardWrapper,
	          { key: index },
	          _react2.default.createElement(
	            ArticleCardItemIcon,
	            null,
	            _react2.default.createElement(_FeatureIcon2.default, { name: article.iconName })
	          ),
	          _react2.default.createElement(
	            ArticleCardItemContent,
	            null,
	            _react2.default.createElement(
	              ArticleCardItemName,
	              null,
	              article.articleName
	            ),
	            _react2.default.createElement(
	              ArticleCardItemDescription,
	              null,
	              article.articleDescription
	            ),
	            _react2.default.createElement(
	              "p",
	              {
	                style: {
	                  color: "#5759FF",
	                  fontSize: "15px",
	                  fontWeight: "700"
	                } },
	              article.articleLinkText
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = function (_ref2) {
	  var articles = _ref2.articles;
	  return _react2.default.createElement(ArticleCard, { articles: articles });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/FeatureCard.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcon = __webpack_require__("./src/components/FeatureIcon.js");
	
	var _FeatureIcon2 = _interopRequireDefault(_FeatureIcon);
	
	var _FillIcon = __webpack_require__("./src/components/FillIcon.js");
	
	var _FillIcon2 = _interopRequireDefault(_FillIcon);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	var _storefront = __webpack_require__("./src/assets/svgs/storefront.svg");
	
	var _storefront2 = _interopRequireDefault(_storefront);
	
	var _AddtoSlack = __webpack_require__("./src/components/AddtoSlack.js");
	
	var _AddtoSlack2 = _interopRequireDefault(_AddtoSlack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureCardWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureCard__FeatureCardWrapper"
	})(["background-color:white;display:flex;justify-content:center;overflow:hidden;margin:0 auto;width:100%;max-width:1200px;border-radius:18px;box-shadow:0px 7px 15px ", ";background-image:url(", ");background-position:70% 90%;background-size:100%;background-repeat:no-repeat;@media (max-width:768px){margin-bottom:40px;}@media (max-width:615px){width:95%;background-size:140%;}"], _colors.SECONDARY_TEXT, _storefront2.default);
	
	var FeatureCardContent = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureCard__FeatureCardContent"
	})(["display:flex;width:600px;text-align:center;margin:50px 0px 100px 0px;flex-direction:column;align-items:center;justify-content:center;padding:15px 0px;padding-right:5px;@media (max-width:480px){margin:10px 0px 20px 0px;padding:5px;}"]);
	var FeatureCardIcon = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureCard__FeatureCardIcon"
	})(["transform:scale(1.2);margin:20px;padding:8px;position:relative;@media (max-width:480px){transform:scale(0.9);margin:5px;padding:3px;}"]);
	
	var FeatureCardTitle = _styledComponents2.default.h3.withConfig({
	  displayName: "FeatureCard__FeatureCardTitle"
	})([""]);
	
	var FeatureCardButton = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureCard__FeatureCardButton"
	})(["margin-top:40px;height:40px;@media (max-width:480px){margin-top:20px;}"]);
	
	var FeatureCard = function FeatureCard(props) {
	  return _react2.default.createElement(
	    FeatureCardWrapper,
	    null,
	    _react2.default.createElement(
	      FeatureCardContent,
	      null,
	      _react2.default.createElement(
	        FeatureCardIcon,
	        null,
	        _react2.default.createElement(_FillIcon2.default, { name: props.name })
	      ),
	      _react2.default.createElement(
	        FeatureCardTitle,
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        FeatureCardButton,
	        null,
	        _react2.default.createElement(_AddtoSlack2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = FeatureCard;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/FeatureGrid.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FillIcon = __webpack_require__("./src/components/FillIcon.js");
	
	var _FillIcon2 = _interopRequireDefault(_FillIcon);
	
	var _FeatureGridItem = __webpack_require__("./src/components/FeatureGridItem.js");
	
	var _FeatureGridItem2 = _interopRequireDefault(_FeatureGridItem);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureGridWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureGrid__FeatureGridWrapper"
	})(["display:flex;margin-bottom:100px;max-width:1200px;width:90%;border-radius:18px;box-shadow:0px 7px 15px ", ";background-color:white;@media (max-width:980px){margin-bottom:150px;}@media (max-width:768px){margin-bottom:100px;}@media (max-width:615px){width:100%;}"], _colors.SECONDARY_TEXT);
	
	var FeatureGrid = function FeatureGrid(props) {
	  return _react2.default.createElement(
	    FeatureGridWrapper,
	    null,
	    _react2.default.createElement(_FeatureGridItem2.default, { features: props.features })
	  );
	};
	
	exports.default = FeatureGrid;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/FeatureGridItem.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FillIcon = __webpack_require__("./src/components/FillIcon.js");
	
	var _FillIcon2 = _interopRequireDefault(_FillIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureGridItemWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureGridItem__FeatureGridItemWrapper"
	})(["text-align:center;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;padding:20px 10px 40px 10px;margin:0 auto;"]);
	
	var FeatureGridItemContent = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureGridItem__FeatureGridItemContent"
	})(["width:30%;max-width:300px;margin:10px 5px 30px 5px;@media (max-width:615px){width:45%;}"]);
	
	var FeatureGridItemIcon = _styledComponents2.default.div.withConfig({
	  displayName: "FeatureGridItem__FeatureGridItemIcon"
	})(["margin-bottom:10px;"]);
	
	var FeatureGridItemTitle = _styledComponents2.default.h4.withConfig({
	  displayName: "FeatureGridItem__FeatureGridItemTitle"
	})(["font-size:16px;@media (max-width:480px){font-size:14px;}"]);
	
	var FeatureGridItemDescription = _styledComponents2.default.p.withConfig({
	  displayName: "FeatureGridItem__FeatureGridItemDescription"
	})(["font-size:15px;line-height:21px;@media (max-width:480px){font-size:13px;line-height:17px;}"]);
	
	var FeatureGridItem = function FeatureGridItem(_ref) {
	  var features = _ref.features;
	
	  if (!features || features.length < 1) {
	    return null;
	  }
	  return _react2.default.createElement(
	    FeatureGridItemWrapper,
	    null,
	    features.map(function (feature, index, props) {
	      return _react2.default.createElement(
	        FeatureGridItemContent,
	        { key: index },
	        _react2.default.createElement(
	          FeatureGridItemIcon,
	          null,
	          _react2.default.createElement(_FillIcon2.default, { name: feature.icon })
	        ),
	        _react2.default.createElement(
	          FeatureGridItemTitle,
	          null,
	          feature.name
	        ),
	        _react2.default.createElement(
	          FeatureGridItemDescription,
	          null,
	          feature.description
	        )
	      );
	    })
	  );
	};
	
	exports.default = function (_ref2) {
	  var features = _ref2.features;
	  return _react2.default.createElement(FeatureGridItem, { features: features });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/FeatureIcon.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureIcons = __webpack_require__("./src/assets/FeatureIcons.js");
	
	var FeatureIcons = _interopRequireWildcard(_FeatureIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureIcon = function FeatureIcon(_ref) {
	  var name = _ref.name,
	      style = _ref.style,
	      size = _ref.size;
	
	  var FeatureIcon = FeatureIcons[name];
	  if (FeatureIcon) {
	    var _style = { width: size, height: size };
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(FeatureIcon, { name: name })
	    );
	  } else {
	    return null;
	  }
	};
	
	FeatureIcon.displayName = 'FeatureIcon';
	
	exports.default = FeatureIcon;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/FillIcon.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FillIcons = __webpack_require__("./src/assets/FillIcons.js");
	
	var FillIcons = _interopRequireWildcard(_FillIcons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FillIcon = function FillIcon(_ref) {
	  var name = _ref.name,
	      style = _ref.style,
	      size = _ref.size;
	
	  var FillIcon = FillIcons[name];
	  if (FillIcon) {
	    var _style = { width: size, height: size };
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(FillIcon, { name: name })
	    );
	  } else {
	    return null;
	  }
	};
	
	FillIcon.displayName = "FillIcon";
	
	FillIcon.defaultProps = {
	  size: 16,
	  color: "#96AAB4"
	};
	
	exports.default = FillIcon;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SectionBlockContent.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionBlockContentWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "SectionBlockContent__SectionBlockContentWrapper"
	})(["position:relative;display:flex;flex-direction:column;z-index:3;width:", ";margin:0 50px;margin-top:50px;@media (max-width:900px){margin-right:0px;}@media (max-width:768px){text-align:center;margin-top:-50px;margin:0px;width:70%;}@media (max-width:480px){text-align:center;margin:0px;width:95%;}"], function (props) {
	  return props.bigIllustration ? "30%" : "50%";
	});
	var SectionBlockHeadline = _styledComponents2.default.h2.withConfig({
	  displayName: "SectionBlockContent__SectionBlockHeadline"
	})(["margin-bottom:20px;@media (max-width:480px){margin-bottom:15px;}"]);
	
	var SectionBlockCopy = _styledComponents2.default.p.withConfig({
	  displayName: "SectionBlockContent__SectionBlockCopy"
	})(["margin-bottom:20px;@media (max-width:768px){margin-bottom:10px;}@media (max-width:480px){margin-bottom:15px;}"]);
	
	var SectionBlockProTip = _styledComponents2.default.p.withConfig({
	  displayName: "SectionBlockContent__SectionBlockProTip"
	})(["color:", ";margin-bottom:40px;@media (max-width:768px){margin-bottom:10px;}"], _colors.SECONDARY_TEXT);
	
	var SectionBlockCTA = _styledComponents2.default.a.withConfig({
	  displayName: "SectionBlockContent__SectionBlockCTA"
	})(["color:", ";margin-bottom:40px;@media (max-width:768px){margin-bottom:10px;}"], _colors.ACTIVE_TEXT);
	
	var SectionBlockContent = function SectionBlockContent(props) {
	  return _react2.default.createElement(
	    SectionBlockContentWrapper,
	    { bigIllustration: props.bigIllustration },
	    _react2.default.createElement(
	      SectionBlockHeadline,
	      null,
	      props.headline
	    ),
	    _react2.default.createElement(
	      SectionBlockCopy,
	      null,
	      props.copy
	    ),
	    _react2.default.createElement(
	      SectionBlockProTip,
	      null,
	      props.protips
	    ),
	    _react2.default.createElement(
	      SectionBlockCTA,
	      { href: props.link },
	      props.linkText
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var bigIllustration = _ref.bigIllustration,
	      headline = _ref.headline,
	      copy = _ref.copy,
	      protips = _ref.protips,
	      link = _ref.link,
	      linkText = _ref.linkText;
	  return _react2.default.createElement(SectionBlockContent, {
	    bigIllustration: bigIllustration,
	    headline: headline,
	    copy: copy,
	    protips: protips,
	    link: link,
	    linkText: linkText
	  });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SectionContainer.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionContainer = _styledComponents2.default.div.withConfig({
	  displayName: "SectionContainer"
	})(["position:relative;z-index:", ";margin:0 auto;padding:0 1.5rem;display:flex;flex-direction:", ";align-items:center;justify-content:center;min-height:", ";width:100%;max-width:1600px;margin-bottom:50px;@media (max-width:980px){align-items:center;justify-content:center;}@media (max-width:768px){flex-direction:column-reverse;align-items:center;justify-content:center;padding:0 1rem;}@media screen and (max-width:615px){padding:0 0.8rem;margin-bottom:20px;}"], function (props) {
	  return props.zIndex;
	}, function (props) {
	  return props.reversed ? "row-reverse" : "row";
	}, function (props) {
	  return props.height;
	});
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      reversed = _ref.reversed,
	      height = _ref.height,
	      zIndex = _ref.zIndex;
	  return _react2.default.createElement(
	    SectionContainer,
	    { zIndex: zIndex, reversed: reversed, height: height },
	    children
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/SectionIllustration.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionIllustrationWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "SectionIllustration__SectionIllustrationWrapper"
	})(["display:flex;align-items:center;position:relative;z-index:", ";left:", ";transform:", ";margin:0 auto;width:", ";@media (max-width:1100px){}@media (max-width:900px){width:60%;}@media (max-width:768px){width:", ";}@media screen and (max-width:420px){width:100%;}"], function (props) {
	  return props.zIndex;
	}, function (props) {
	  return props.position;
	}, function (props) {
	  return props.transform;
	}, function (props) {
	  return props.bigIllustration ? "70%" : "50%";
	}, function (props) {
	  return props.isChat ? "80%" : "100%";
	});
	
	var SectionIllustration = function SectionIllustration(props) {
	  return _react2.default.createElement(
	    SectionIllustrationWrapper,
	    {
	      bigIllustration: props.bigIllustration,
	      transform: props.transform,
	      position: props.position,
	      zIndex: props.zIndex },
	    _react2.default.createElement("img", { src: props.name })
	  );
	};
	
	exports.default = function (_ref) {
	  var name = _ref.name,
	      position = _ref.position,
	      transform = _ref.transform,
	      bigIllustration = _ref.bigIllustration,
	      zIndex = _ref.zIndex;
	  return _react2.default.createElement(SectionIllustration, {
	    bigIllustration: bigIllustration,
	    name: name,
	    transform: transform,
	    position: position,
	    zIndex: zIndex
	  });
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-react/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-stage-0/lib/index.js\",[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/robertgonzales/Sites/smallchat/website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-styled-components/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/robertgonzales/Sites/smallchat/website/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/features.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__("./src/components/consts/colors.js");
	
	var _FeatureHeaderBackground = __webpack_require__("./src/assets/pngs/FeatureHeaderBackground.png");
	
	var _FeatureHeaderBackground2 = _interopRequireDefault(_FeatureHeaderBackground);
	
	var _sideBySide = __webpack_require__("./src/assets/svgs/sideBySide.svg");
	
	var _sideBySide2 = _interopRequireDefault(_sideBySide);
	
	var _bkgAm = __webpack_require__("./src/assets/pngs/bkg-am.png");
	
	var _bkgAm2 = _interopRequireDefault(_bkgAm);
	
	var _autoMessage = __webpack_require__("./src/assets/svgs/autoMessage.svg");
	
	var _autoMessage2 = _interopRequireDefault(_autoMessage);
	
	var _bkgCustomize = __webpack_require__("./src/assets/pngs/bkg-customize.png");
	
	var _bkgCustomize2 = _interopRequireDefault(_bkgCustomize);
	
	var _customize = __webpack_require__("./src/assets/svgs/customize.svg");
	
	var _customize2 = _interopRequireDefault(_customize);
	
	var _SectionThreeBackground = __webpack_require__("./src/assets/pngs/SectionThreeBackground.png");
	
	var _SectionThreeBackground2 = _interopRequireDefault(_SectionThreeBackground);
	
	var _FeatureGrid = __webpack_require__("./src/components/FeatureGrid.js");
	
	var _FeatureGrid2 = _interopRequireDefault(_FeatureGrid);
	
	var _AddtoSlack = __webpack_require__("./src/components/AddtoSlack.js");
	
	var _AddtoSlack2 = _interopRequireDefault(_AddtoSlack);
	
	var _ArticleCard = __webpack_require__("./src/components/ArticleCard.js");
	
	var _ArticleCard2 = _interopRequireDefault(_ArticleCard);
	
	var _FeatureCard = __webpack_require__("./src/components/FeatureCard.js");
	
	var _FeatureCard2 = _interopRequireDefault(_FeatureCard);
	
	var _SectionBackground = __webpack_require__("./src/components/SectionBackground.js");
	
	var _SectionBackground2 = _interopRequireDefault(_SectionBackground);
	
	var _SectionContainer = __webpack_require__("./src/components/SectionContainer.js");
	
	var _SectionContainer2 = _interopRequireDefault(_SectionContainer);
	
	var _SectionIllustration = __webpack_require__("./src/components/SectionIllustration.js");
	
	var _SectionIllustration2 = _interopRequireDefault(_SectionIllustration);
	
	var _SectionBlockContent = __webpack_require__("./src/components/SectionBlockContent.js");
	
	var _SectionBlockContent2 = _interopRequireDefault(_SectionBlockContent);
	
	var _withScreensize = __webpack_require__("./src/components/withScreensize.js");
	
	var _withScreensize2 = _interopRequireDefault(_withScreensize);
	
	var _SectionCallout = __webpack_require__("./src/components/SectionCallout.js");
	
	var _SectionCallout2 = _interopRequireDefault(_SectionCallout);
	
	var _SectionCalloutBackground = __webpack_require__("./src/assets/svgs/SectionCalloutBackground.svg");
	
	var _SectionCalloutBackground2 = _interopRequireDefault(_SectionCalloutBackground);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = [{
	  icon: "clock",
	  name: "Offline Scheduling",
	  description: "Let your customers know when your team is around and available to help."
	}, {
	  icon: "autoMessages",
	  name: "Auto Messaging",
	  description: "Get the conversation started! Actively engage visitors with custom trigger messages."
	}, {
	  icon: "profile",
	  name: "Know your Users",
	  description: "Use the Smallchat API to add data and know more about the visitors you're chatting with."
	}, {
	  icon: "unlimited",
	  name: "Unlimited Chats",
	  description: "Don't worry about your bill going up if your customers are chatty. Unlimited messages on every tier."
	}, {
	  icon: "analytics",
	  name: "Custom Analytics",
	  description: "Track the number of conversations you're having each month."
	}, {
	  icon: "channels",
	  name: "Multiple Channels",
	  description: "Manage multiple sites from the same Slack team by creating a channel for each site."
	}, {
	  icon: "customize",
	  name: "Fully Customizable",
	  description: "Style your widget to match your unique brand."
	}, {
	  icon: "edit",
	  name: "Edit Sent Messages",
	  description: "No need to fret over typos. Edit or delete messages after they've been sent."
	}, {
	  icon: "website",
	  name: "Use Across Multiple Sites",
	  description: "Use Smallchat on multiple sites from a single Slack team, or add multiple Slack teams to a single Smallchat subscription."
	}, {
	  icon: "slack",
	  name: "Slack + Smallchat",
	  description: "Smallchat integrates seamlessly with Slack. Conversations create a new thread in your support channel."
	}, {
	  icon: "world",
	  name: "Support Multiple Languages",
	  description: "Create multiple widgets for different language versions of your site."
	}, {
	  icon: "phone",
	  name: "Chat On the Go",
	  description: "Chat from Slack's native mobile app, and get notifications when a customer starts a conversation."
	}];
	
	var FeatureGridHeader = _styledComponents2.default.h2.withConfig({
	  displayName: "features__FeatureGridHeader"
	})(["z-index:2;max-width:600px;text-align:center;padding:0 50px;h2{display:inline-block;}@media screen and (max-width:768px){margin-top:80px;padding:0 20px;}"]);
	
	var FeatureWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "features__FeatureWrapper"
	})(["display:flex;flex-direction:column;max-width:1600px;margin:0 auto;width:100%;"]);
	
	function Feature(_ref) {
	  var screensize = _ref.screensize;
	
	  var isMobile = screensize === "phone";
	  var isLargeMobile = screensize === "l-phone";
	  var isTablet = screensize === "tablet";
	  var isSmall = screensize === "small";
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: "Smallchat Features" }),
	    _react2.default.createElement(
	      FeatureWrapper,
	      null,
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          height: isMobile ? "90vh" : isTablet ? "80vh" : "70vh" },
	        _react2.default.createElement(_SectionBlockContent2.default, {
	          headline: "Realtime interactions.",
	          copy: "Smallchat lets you engage visitors as they're browsing. People don\u2019t want to wait and put a potential purchase on hold while they wait for an email response. Real-time chat allows you to answer visitor questions in real-time, converting more visitors to customers."
	        }),
	        _react2.default.createElement(_SectionIllustration2.default, {
	          position: isMobile ? "-18%" : isTablet ? "10%" : "0%",
	          transform: isMobile ? "scale(.55)" : isTablet ? "scale(.85)" : "scale(.9)",
	          name: _sideBySide2.default
	        }),
	        _react2.default.createElement(_SectionBackground2.default, {
	          background: _FeatureHeaderBackground2.default,
	          backgroundHeight: isMobile ? "80%" : isTablet ? "110%" : "140%",
	          backgroundWidth: isMobile ? "140%" : isTablet ? "150%" : "160%",
	          backgroundScale: isMobile ? "1.1" : isTablet ? "1" : ".9"
	        })
	      ),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          height: isMobile ? "45vh" : isTablet ? "1.6" : "50vh" },
	        _react2.default.createElement(_FeatureCard2.default, {
	          name: "unlimited",
	          title: "Get Unlimited Operators, Conversations, and Messages. For Free."
	        })
	      ),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          reversed: true,
	          height: isMobile ? "50vh" : isTablet ? "60vh" : "70vh" },
	        _react2.default.createElement(_SectionBlockContent2.default, {
	          bigIllustration: true,
	          headline: "Automate Engagement",
	          copy: "Get the conversation started! Actively engage visitors with custom trigger messages."
	          // link="/"
	          // linkText="Learn More about Auto Messages"
	        }),
	        _react2.default.createElement(_SectionIllustration2.default, {
	          bigIllustration: true,
	          position: isMobile ? "-25%" : isTablet ? "0%" : isSmall ? "-25%" : "-5%",
	          transform: isMobile ? "scale(.45)" : isTablet ? "scale(.75)" : "scale(.9)",
	          name: _autoMessage2.default
	        }),
	        _react2.default.createElement(_SectionBackground2.default, {
	          background: _bkgAm2.default,
	          backgroundHeight: "100%",
	          backgroundWidth: "120%",
	          backgroundRight: isMobile ? "0%" : isTablet ? "0%" : "40%",
	          backgroundScale: isMobile ? "1.1" : isTablet ? "1" : "1"
	        })
	      ),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          height: isMobile ? "100vh" : isTablet ? "90vh" : "90vh" },
	        _react2.default.createElement(_SectionBlockContent2.default, {
	          headline: "Fully Customizable",
	          copy: "Customize your site's widget with quick & easy styling to seamlessly integrate Smallchat with your brand.",
	          protips: "\uD83D\uDCA1 All forms & fields are completely customizable to work in any language!"
	          // link="/"
	          // linkText="See it in Action!"
	        }),
	        _react2.default.createElement(_SectionIllustration2.default, {
	          position: isMobile ? "-27%" : isTablet ? "0%" : "0%",
	          transform: isMobile ? "scale(.45)" : isTablet ? "scale(.7)" : "scale(.9)",
	          name: _customize2.default
	        }),
	        _react2.default.createElement(_SectionBackground2.default, {
	          background: _bkgCustomize2.default,
	          backgroundHeight: isMobile ? "90%" : isTablet ? "95%" : "100%",
	          backgroundWidth: isMobile ? "160%" : isTablet ? "120%" : "100%",
	          backgroundRight: "-60%",
	          backgroundScale: isMobile ? ".9" : isTablet ? "1" : "1.2"
	        })
	      ),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          height: isMobile ? "30vh" : isTablet ? "10vh" : "30vh" },
	        _react2.default.createElement(
	          FeatureGridHeader,
	          null,
	          "All the Features you need, whatever your business."
	        )
	      ),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        {
	          height: isMobile ? "200vh" : isLargeMobile ? "180vh" : isTablet ? "140vh" : "90vh" },
	        _react2.default.createElement(_FeatureGrid2.default, { features: features }),
	        _react2.default.createElement(_SectionBackground2.default, {
	          background: _SectionThreeBackground2.default,
	          backgroundHeight: "100%",
	          backgroundWidth: "100%",
	          backgroundRight: "40%",
	          backgroundScale: isMobile ? ".8" : isTablet ? "1" : "1.2"
	        })
	      ),
	      _react2.default.createElement(_SectionCallout2.default, {
	        darkShadow: true,
	        background: _SectionCalloutBackground2.default,
	        backgroundSize: "cover",
	        backgroundPosition: "80% 80%",
	        title: "Start your conversations today."
	      })
	    )
	  );
	}
	
	exports.default = (0, _withScreensize2.default)(Feature);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-js-0f24f409b0b6ebc34f7c.js